import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Currency: string;
  Cursor: any;
  EncodedFileInput: string;
  Timestamp: string;
};

export type AccessPagePageFilterInput = {
  email?: InputMaybe<Scalars['String']>;
};

export type AccessPagePageSortInput = {
  direction: SortDirection;
  field: Scalars['String'];
};

export type AccessPass = Node & {
  __typename?: 'AccessPass';
  email: Scalars['String'];
  endDate: Scalars['Timestamp'];
  id: Scalars['ID'];
  note: Scalars['String'];
  startDate: Scalars['Timestamp'];
};

export type AccessPassPage = Page & {
  __typename?: 'AccessPassPage';
  nodes: Array<AccessPass>;
  pageInfo: PageInfo;
};

export type AccessPassPageQueryOptions = {
  filter?: InputMaybe<AccessPagePageFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
  sort?: InputMaybe<AccessPagePageSortInput>;
};

export type ActorStage = {
  __typename?: 'ActorStage';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: ActorStageName;
  overrideDisplayName?: Maybe<Scalars['String']>;
};

export type ActorStageName =
  | 'committed'
  | 'dataRoomAccess'
  | 'favorites'
  | 'followedUp'
  | 'inDiligence'
  | 'initialMeeting'
  | 'passed'
  | 'reachedOut';

export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: Scalars['String'];
  usState?: Maybe<Scalars['String']>;
};

export type ApiFile = {
  __typename?: 'ApiFile';
  fileName: Scalars['String'];
  id: Scalars['ID'];
  key: Scalars['String'];
};

export type BulkImportInvestmentAreasInput = {
  displayNames: Array<Scalars['String']>;
};

export type BulkImportUserInput = {
  checkSizeMax?: InputMaybe<Scalars['String']>;
  checkSizeMin?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  companyDescription: Scalars['String'];
  companyName: Scalars['String'];
  country: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  investmentAreas: Array<Scalars['ID']>;
  investmentCategories: Array<InvestmentCategoryName>;
  investmentGeographies: Array<InvestmentGeographyName>;
  investmentStages: Array<InvestmentStageName>;
  lastName?: InputMaybe<Scalars['String']>;
  logoUrl: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  usState?: InputMaybe<Scalars['String']>;
  websiteUrl: Scalars['String'];
};

export type BulkImportUsersInput = {
  userType: UserTypeName;
  users: Array<BulkImportUserInput>;
};

export type Campaign = {
  __typename?: 'Campaign';
  amountRaisedDollars: Scalars['Int'];
  completedAt?: Maybe<Scalars['Timestamp']>;
  creationDate: Scalars['Timestamp'];
  description: Scalars['String'];
  fundingStage: FundingStage;
  id: Scalars['ID'];
  investorCards: Array<InvestorCard>;
  name: Scalars['String'];
  targetAmountDollars: Scalars['Int'];
  targetCloseDate?: Maybe<Scalars['Timestamp']>;
};

export type CompanyProfile = {
  __typename?: 'CompanyProfile';
  address: Address;
  description: Scalars['String'];
  id: Scalars['ID'];
  investmentAreas: Array<InvestmentArea>;
  investmentCategory?: Maybe<InvestmentCategory>;
  investmentGeographies: Array<InvestmentGeography>;
  investmentStages?: Maybe<Array<InvestmentStage>>;
  isVisible: Scalars['Boolean'];
  logo?: Maybe<ApiFile>;
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
  websiteUrl: Scalars['String'];
};

export type CreateAccountInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  userId: Scalars['ID'];
};

export type CreateSubscriptionInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  discountCode?: InputMaybe<Scalars['String']>;
  usState: Scalars['String'];
  zipCode: Scalars['String'];
};

export type DownloadLimitCategory = {
  __typename?: 'DownloadLimitCategory';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: DownloadLimitCategoryName;
};

export type DownloadLimitCategoryName =
  | 'freeUsers'
  | 'paidUsers';

export type DownloadLimitSetting = {
  __typename?: 'DownloadLimitSetting';
  category: DownloadLimitCategory;
  id: Scalars['ID'];
  limit: Scalars['Int'];
};

export type FavoriteInvestorInput = {
  favoritedInvestorUserId: Scalars['String'];
  isFavorited: Scalars['Boolean'];
};

export type FundingStage = {
  __typename?: 'FundingStage';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: FundingStageName;
};

export type FundingStageName =
  | 'other'
  | 'preSeed'
  | 'seed'
  | 'seriesA'
  | 'seriesB'
  | 'seriesC';

export type InvestmentArea = {
  __typename?: 'InvestmentArea';
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type InvestmentCategory = {
  __typename?: 'InvestmentCategory';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: InvestmentCategoryName;
};

export type InvestmentCategoryName =
  | 'acceleratorIncubator'
  | 'angelGroup'
  | 'corporateVentureCapital'
  | 'startups'
  | 'ventureCapital';

export type InvestmentGeography = {
  __typename?: 'InvestmentGeography';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: InvestmentGeographyName;
  parentName?: Maybe<InvestmentGeographyName>;
  ranking: Scalars['Int'];
};

export type InvestmentGeographyName =
  | 'africa'
  | 'agnostic'
  | 'asia'
  | 'australiaNZ'
  | 'bayAreaUS'
  | 'canada'
  | 'china'
  | 'europe'
  | 'india'
  | 'ireland'
  | 'israel'
  | 'japan'
  | 'mexico'
  | 'middleEast'
  | 'midwestUS'
  | 'newYorkCityUS'
  | 'northAmerica'
  | 'northeastUS'
  | 'northwestUS'
  | 'singapore'
  | 'southAmerica'
  | 'southeastUS'
  | 'southwestUS'
  | 'uk'
  | 'us';

export type InvestmentOption = {
  __typename?: 'InvestmentOption';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: InvestmentOptionName;
};

export type InvestmentOptionName =
  | 'convertibleDebt'
  | 'equity';

export type InvestmentStage = {
  __typename?: 'InvestmentStage';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: InvestmentStageName;
};

export type InvestmentStageName =
  | 'growth'
  | 'preSeed'
  | 'seed'
  | 'venture';

export type InvestorCard = {
  __typename?: 'InvestorCard';
  campaign: Campaign;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  investorProfile?: Maybe<InvestorProfile>;
  notes: Array<Note>;
  potentialInvestmentAmountDollars: Scalars['Int'];
  stage: ActorStage;
};

export type InvestorProfile = {
  __typename?: 'InvestorProfile';
  canLeadInvestments: Scalars['Boolean'];
  checkSizeMaxDollars?: Maybe<Scalars['Int']>;
  checkSizeMinDollars?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isVerifiedInvestor: Scalars['Boolean'];
};

export type InviteSuperAdminInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
};

export type LegalDocument = {
  __typename?: 'LegalDocument';
  extension: Scalars['String'];
  file: ApiFile;
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type LegalTerm = {
  __typename?: 'LegalTerm';
  bodyText: Scalars['String'];
  id: Scalars['ID'];
  investmentOption: InvestmentOption;
  title: Scalars['String'];
};

export type LegalTermDetail = {
  __typename?: 'LegalTermDetail';
  description: Scalars['String'];
  id: Scalars['ID'];
  illustrativeWording: Scalars['String'];
  scenarioModeling: Scalars['String'];
  semantics: Scalars['String'];
  title: Scalars['String'];
  whatsTypical: Scalars['String'];
  whereElseToCheckInTermSheet: Scalars['String'];
  whereToFindInFullDocs: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  bulkImportInvestmentAreas: Array<InvestmentArea>;
  bulkImportUsers: Array<SiteUserFull>;
  cancelSubscription?: Maybe<SiteUserFull>;
  createAccount?: Maybe<SiteUserFull>;
  createSubscription: SubscriptionSecrets;
  deleteCampaign: Scalars['Boolean'];
  deleteInvestmentArea: Scalars['Boolean'];
  deleteLoggedInUser: Scalars['Boolean'];
  deleteNote: Scalars['ID'];
  deleteUsers: Scalars['Boolean'];
  endTrialEarly: Scalars['Boolean'];
  favoriteInvestor: Scalars['Boolean'];
  inviteSuperAdmin?: Maybe<SiteUserFull>;
  markCampaignComplete: Scalars['Boolean'];
  overrideActorStageDisplayName: ActorStage;
  ping: Scalars['Boolean'];
  registerSiteUser?: Maybe<SiteUserFull>;
  reopenCampaign: Scalars['Boolean'];
  saveAccessPass?: Maybe<AccessPass>;
  saveCampaign: Campaign;
  saveCompanyProfile?: Maybe<CompanyProfile>;
  saveDownloadLimitSetting?: Maybe<DownloadLimitSetting>;
  saveInvestmentArea?: Maybe<InvestmentArea>;
  saveInvestorCard?: Maybe<InvestorCard>;
  saveInvestorProfile?: Maybe<InvestorProfile>;
  saveNote: Note;
  saveSiteUser?: Maybe<SiteUserFull>;
  toggleAllAccess: Scalars['Boolean'];
  updateCompanyProfileVisibility?: Maybe<CompanyProfile>;
  updatePaymentInfo?: Maybe<PaymentInfo>;
};


export type MutationBulkImportInvestmentAreasArgs = {
  input: BulkImportInvestmentAreasInput;
};


export type MutationBulkImportUsersArgs = {
  input: BulkImportUsersInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInvestmentAreaArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteUsersArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationFavoriteInvestorArgs = {
  input: FavoriteInvestorInput;
};


export type MutationInviteSuperAdminArgs = {
  input: InviteSuperAdminInput;
};


export type MutationMarkCampaignCompleteArgs = {
  id: Scalars['ID'];
};


export type MutationOverrideActorStageDisplayNameArgs = {
  input: OverrideActorStageDisplayNameInput;
};


export type MutationRegisterSiteUserArgs = {
  input: RegisterSiteUserInput;
};


export type MutationReopenCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationSaveAccessPassArgs = {
  input: SaveAccessPassInput;
};


export type MutationSaveCampaignArgs = {
  input: SaveCampaignInput;
};


export type MutationSaveCompanyProfileArgs = {
  input: SaveCompanyProfileInput;
};


export type MutationSaveDownloadLimitSettingArgs = {
  input: SaveDownloadLimitSettingInput;
};


export type MutationSaveInvestmentAreaArgs = {
  input: SaveInvestmentAreaInput;
};


export type MutationSaveInvestorCardArgs = {
  input: SaveInvestorCardInput;
};


export type MutationSaveInvestorProfileArgs = {
  input: SaveInvestorProfileInput;
};


export type MutationSaveNoteArgs = {
  input: SaveNoteInput;
};


export type MutationSaveSiteUserArgs = {
  input: SaveSiteUserInput;
};


export type MutationToggleAllAccessArgs = {
  enabled: Scalars['Boolean'];
};


export type MutationUpdateCompanyProfileVisibilityArgs = {
  input: UpdateCompanyProfileVisibilityInput;
};


export type MutationUpdatePaymentInfoArgs = {
  input: UpdatePaymentInfoInput;
};

export type Node = {
  id: Scalars['ID'];
};

export type Note = {
  __typename?: 'Note';
  body: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type OverrideActorStageDisplayNameInput = {
  actorStageName: ActorStageName;
  overrideDisplayName: Scalars['String'];
};

export type Page = {
  nodes: Array<Node>;
  pageInfo: PageInfo;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  nextPage?: Maybe<Scalars['Cursor']>;
  pages: Array<Scalars['Cursor']>;
  previousPage?: Maybe<Scalars['Cursor']>;
  totalRows: Scalars['Int'];
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
};

export type PaymentInfo = {
  __typename?: 'PaymentInfo';
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  usState: Scalars['String'];
  zipCode: Scalars['String'];
};

export type PitchDeckTopic = {
  __typename?: 'PitchDeckTopic';
  bodyText: Scalars['String'];
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type PitchDeckTopicDetail = {
  __typename?: 'PitchDeckTopicDetail';
  closingThoughts: Scalars['String'];
  commonSuccesses: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  potentialPitfalls: Scalars['String'];
  title: Scalars['String'];
  whatYouWillNeed: Scalars['String'];
  whyIsThisImportant: Scalars['String'];
};

export type ProfilePicture = {
  __typename?: 'ProfilePicture';
  id: Scalars['String'];
  url: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  accessPass?: Maybe<AccessPass>;
  accessPasses: AccessPassPage;
  actorStages: Array<ActorStage>;
  allAccessEnabled: Scalars['Boolean'];
  campaign?: Maybe<Campaign>;
  downloadLimitSettings: Array<DownloadLimitSetting>;
  favoritedInvestors: Array<SiteUserFull>;
  fundingStages: Array<FundingStage>;
  investmentArea?: Maybe<InvestmentArea>;
  investmentAreas: Array<InvestmentArea>;
  investmentCategories: Array<InvestmentCategory>;
  investmentGeographies: Array<InvestmentGeography>;
  investmentOption: Array<InvestmentOption>;
  investmentStages: Array<InvestmentStage>;
  investorCard?: Maybe<InvestorCard>;
  legalDocuments: Array<LegalDocument>;
  legalTermDetail?: Maybe<LegalTermDetail>;
  legalTerms: Array<LegalTerm>;
  loggedInUser?: Maybe<SiteUserFull>;
  myCampaigns: Array<Campaign>;
  note: Note;
  pitchDeckTopicDetail?: Maybe<PitchDeckTopicDetail>;
  pitchDeckTopics: Array<PitchDeckTopic>;
  slides: Array<Slide>;
  usStates: Array<UsState>;
  user?: Maybe<SiteUserFull>;
  users: SiteUserFullPage;
  validateEmailsAvailable?: Maybe<Array<Scalars['String']>>;
  verifyEmailNotInUse: Scalars['Boolean'];
  version: Scalars['String'];
};


export type QueryAccessPassArgs = {
  id: Scalars['ID'];
};


export type QueryAccessPassesArgs = {
  options: AccessPassPageQueryOptions;
};


export type QueryCampaignArgs = {
  id: Scalars['ID'];
};


export type QueryInvestmentAreaArgs = {
  id: Scalars['ID'];
};


export type QueryInvestorCardArgs = {
  id: Scalars['ID'];
};


export type QueryLegalDocumentsArgs = {
  extension?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryLegalTermDetailArgs = {
  title: Scalars['String'];
};


export type QueryNoteArgs = {
  id: Scalars['ID'];
};


export type QueryPitchDeckTopicDetailArgs = {
  title: Scalars['String'];
};


export type QuerySlidesArgs = {
  input?: InputMaybe<SlideQueryInput>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  filterInput?: InputMaybe<UsersFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
  sortInput?: InputMaybe<UsersSortInput>;
};


export type QueryValidateEmailsAvailableArgs = {
  emails: Array<Scalars['String']>;
};


export type QueryVerifyEmailNotInUseArgs = {
  email: Scalars['String'];
};

export type RegisterSiteUserInput = {
  authProviderUserId: Scalars['ID'];
  email: Scalars['String'];
};

export type SaveAccessPassInput = {
  email?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['Timestamp']>;
  id?: InputMaybe<Scalars['ID']>;
  note?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Timestamp']>;
};

export type SaveAddressInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  usState?: InputMaybe<Scalars['String']>;
};

export type SaveCampaignInput = {
  description?: InputMaybe<Scalars['String']>;
  fundingStage: FundingStageName;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  targetAmountDollars: Scalars['Int'];
  targetCloseDate?: InputMaybe<Scalars['Timestamp']>;
};

export type SaveCompanyProfileInput = {
  address?: InputMaybe<SaveAddressInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  investmentAreas?: InputMaybe<Array<Scalars['ID']>>;
  investmentCategory?: InputMaybe<InvestmentCategoryName>;
  investmentGeographies?: InputMaybe<Array<InvestmentGeographyName>>;
  investmentStages?: InputMaybe<Array<InvestmentStageName>>;
  logo?: InputMaybe<Scalars['EncodedFileInput']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type SaveDownloadLimitSettingInput = {
  categoryName: DownloadLimitCategoryName;
  limit: Scalars['Int'];
};

export type SaveInvestmentAreaInput = {
  displayName: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
};

export type SaveInvestorCardInput = {
  campaignId?: InputMaybe<Scalars['ID']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  investorId?: InputMaybe<Scalars['ID']>;
  potentialInvestmentAmountDollars?: InputMaybe<Scalars['Int']>;
  stageName?: InputMaybe<ActorStageName>;
};

export type SaveInvestorProfileInput = {
  canLeadInvestments?: InputMaybe<Scalars['Boolean']>;
  checkSizeMaxDollars?: InputMaybe<Scalars['Int']>;
  checkSizeMinDollars?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  isVerifiedInvestor?: InputMaybe<Scalars['Boolean']>;
};

export type SaveNoteInput = {
  body?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  investorCardId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

export type SaveSiteUserInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserTypeName>;
};

export type SiteUserFull = Node & {
  __typename?: 'SiteUserFull';
  activeAccessPass?: Maybe<AccessPass>;
  companyProfile?: Maybe<CompanyProfile>;
  createdTimestamp: Scalars['Timestamp'];
  downloadUsageForCycle: Scalars['Int'];
  downloadsAllowed: Scalars['Int'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  investorProfile?: Maybe<InvestorProfile>;
  isClaimed: Scalars['Boolean'];
  isSuperAdmin: Scalars['Boolean'];
  lastName: Scalars['String'];
  paymentInfo?: Maybe<PaymentInfo>;
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  subscriptionStatus: SubscriptionStatusName;
  type?: Maybe<UserType>;
};

export type SiteUserFullPage = Page & {
  __typename?: 'SiteUserFullPage';
  nodes: Array<SiteUserFull>;
  pageInfo: PageInfo;
};

export type Slide = {
  __typename?: 'Slide';
  id: Scalars['ID'];
  slide: ApiFile;
  slideGroup: SlideGroup;
  thumbnail: ApiFile;
  title: Scalars['String'];
};

export type SlideGroup = {
  __typename?: 'SlideGroup';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: SlideGroupName;
};

export type SlideGroupName =
  | 'byPitchExample'
  | 'bySlideType'
  | 'otherResources';

export type SlideQueryInput = {
  group?: InputMaybe<SlideGroupName>;
  title?: InputMaybe<Scalars['String']>;
};

export type SortDirection =
  | 'ascending'
  | 'descending';

export type StripeSubscriptionStatus =
  | 'active'
  | 'canceled'
  | 'incomplete'
  | 'incomplete_expired'
  | 'past_due'
  | 'trialing'
  | 'unpaid';

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  currentPeriodEnd: Scalars['Timestamp'];
  currentPeriodStart: Scalars['Timestamp'];
  id: Scalars['String'];
  status: StripeSubscriptionStatus;
  willCancelAtPeriodEnd: Scalars['Boolean'];
};

export type SubscriptionSecrets = {
  __typename?: 'SubscriptionSecrets';
  paymentIntentClientSecret: Scalars['String'];
  setupIntentClientSecret: Scalars['String'];
};

export type SubscriptionStatusName =
  | 'cancel'
  | 'failed'
  | 'incomplete'
  | 'success';

export type UsState = {
  __typename?: 'USState';
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type UpdateCompanyProfileVisibilityInput = {
  companyProfileId: Scalars['ID'];
  isVisible: Scalars['Boolean'];
};

export type UpdatePaymentInfoInput = {
  address: Scalars['String'];
  city: Scalars['String'];
  country: Scalars['String'];
  paymentId: Scalars['String'];
  usState: Scalars['String'];
  zipCode: Scalars['String'];
};

export type UserType = {
  __typename?: 'UserType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: UserTypeName;
};

export type UserTypeName =
  | 'investor'
  | 'startupFounder';

export type UsersFilterInput = {
  canLeadInvestments?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  investmentAreas?: InputMaybe<Array<Scalars['ID']>>;
  investmentCategories?: InputMaybe<Array<InvestmentCategoryName>>;
  investmentGeographies?: InputMaybe<Array<InvestmentGeographyName>>;
  investmentStages?: InputMaybe<Array<InvestmentStageName>>;
  isFavorited?: InputMaybe<Scalars['Boolean']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  searchText?: InputMaybe<Scalars['String']>;
  usState?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<UserTypeName>;
  verifiedByRidge?: InputMaybe<Scalars['Boolean']>;
};

export type UsersSortField =
  | 'name';

export type UsersSortInput = {
  direction: SortDirection;
  field: UsersSortField;
};

export type DebugActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type DebugActivityQuery = { __typename?: 'Query', version: string, users: { __typename?: 'SiteUserFullPage', nodes: Array<{ __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, email?: string | null, type?: { __typename?: 'UserType', id: string, displayName: string } | null }> } };

export type DeleteCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCampaignMutation = { __typename?: 'Mutation', deleteCampaign: boolean };

export type FundraiseActivityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FundraiseActivityQuery = { __typename?: 'Query', favoritedInvestors: Array<{ __typename?: 'SiteUserFull', id: string, investorProfile?: { __typename?: 'InvestorProfile', id: string } | null, companyProfile?: { __typename?: 'CompanyProfile', id: string, name: string } | null }>, campaign?: { __typename?: 'Campaign', id: string, name: string, description: string, amountRaisedDollars: number, targetAmountDollars: number, targetCloseDate?: string | null, completedAt?: string | null, investorCards: Array<{ __typename?: 'InvestorCard', id: string, displayName: string, potentialInvestmentAmountDollars: number, stage: { __typename?: 'ActorStage', id: string, name: ActorStageName }, investorProfile?: { __typename?: 'InvestorProfile', id: string } | null, notes: Array<{ __typename?: 'Note', id: string, title: string, body: string }> }>, fundingStage: { __typename?: 'FundingStage', id: string, name: FundingStageName, displayName: string } } | null, actorStages: Array<{ __typename?: 'ActorStage', id: string, name: ActorStageName, displayName: string, overrideDisplayName?: string | null }> };

export type DeleteNoteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNoteMutation = { __typename?: 'Mutation', deleteNote: string };

export type MarkCampaignCompleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MarkCampaignCompleteMutation = { __typename?: 'Mutation', markCampaignComplete: boolean };

export type ReopenCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ReopenCampaignMutation = { __typename?: 'Mutation', reopenCampaign: boolean };

export type SaveInvestorCardMutationVariables = Exact<{
  input: SaveInvestorCardInput;
}>;


export type SaveInvestorCardMutation = { __typename?: 'Mutation', saveInvestorCard?: { __typename?: 'InvestorCard', id: string, displayName: string, potentialInvestmentAmountDollars: number, investorProfile?: { __typename?: 'InvestorProfile', id: string } | null, stage: { __typename?: 'ActorStage', id: string, name: ActorStageName, displayName: string }, campaign: { __typename?: 'Campaign', id: string, amountRaisedDollars: number } } | null };

export type HomeActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeActivityQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, email?: string | null } | null };

export type InvestorProfileActivityQueryVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type InvestorProfileActivityQuery = { __typename?: 'Query', favoritedInvestors: Array<{ __typename?: 'SiteUserFull', id: string }>, user?: { __typename?: 'SiteUserFull', id: string, companyProfile?: { __typename?: 'CompanyProfile', id: string, name: string, description: string, websiteUrl: string, logo?: { __typename?: 'ApiFile', id: string, key: string } | null, address: { __typename?: 'Address', city: string, usState?: string | null, country: string }, investmentCategory?: { __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName, displayName: string } | null, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }> | null, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName, displayName: string }> } | null, investorProfile?: { __typename?: 'InvestorProfile', id: string, canLeadInvestments: boolean, checkSizeMinDollars?: number | null, checkSizeMaxDollars?: number | null, isVerifiedInvestor: boolean } | null } | null };

export type InvestorsActivityQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UsersFilterInput>;
  sort?: InputMaybe<UsersSortInput>;
}>;


export type InvestorsActivityQuery = { __typename?: 'Query', favoritedInvestors: Array<{ __typename?: 'SiteUserFull', id: string }>, users: { __typename?: 'SiteUserFullPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'SiteUserFull', id: string, companyProfile?: { __typename?: 'CompanyProfile', id: string, name: string, websiteUrl: string, description: string, logo?: { __typename?: 'ApiFile', id: string, key: string } | null } | null }> } };

export type LegalTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type LegalTermsQuery = { __typename?: 'Query', legalTerms: Array<{ __typename?: 'LegalTerm', id: string, title: string, bodyText: string, investmentOption: { __typename?: 'InvestmentOption', id: string, name: InvestmentOptionName, displayName: string } }> };

export type MyFundraisesActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type MyFundraisesActivityQuery = { __typename?: 'Query', myCampaigns: Array<{ __typename?: 'Campaign', id: string, name: string, creationDate: string, targetCloseDate?: string | null, amountRaisedDollars: number, targetAmountDollars: number, completedAt?: string | null, fundingStage: { __typename?: 'FundingStage', id: string, name: FundingStageName, displayName: string } }> };

export type EditPaymentSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type EditPaymentSectionQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, paymentInfo?: { __typename?: 'PaymentInfo', id: string, country: string, usState: string, city: string, address: string, zipCode: string } | null } | null };

export type UpdatePaymentInfoMutationVariables = Exact<{
  input: UpdatePaymentInfoInput;
}>;


export type UpdatePaymentInfoMutation = { __typename?: 'Mutation', updatePaymentInfo?: { __typename?: 'PaymentInfo', id: string, address: string, city: string, country: string, usState: string, zipCode: string } | null };

export type EditProfileSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type EditProfileSectionQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, email?: string | null, type?: { __typename?: 'UserType', id: string, name: UserTypeName, displayName: string } | null, companyProfile?: { __typename?: 'CompanyProfile', id: string, websiteUrl: string, name: string, phoneNumber: string, description: string, address: { __typename?: 'Address', city: string, usState?: string | null, country: string }, investmentCategory?: { __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName, displayName: string } | null, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }> | null, investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName, displayName: string }> } | null, investorProfile?: { __typename?: 'InvestorProfile', id: string, checkSizeMinDollars?: number | null, checkSizeMaxDollars?: number | null } | null } | null };

export type SaveMyProfileMutationVariables = Exact<{
  input: SaveSiteUserInput;
  profileInput: SaveCompanyProfileInput;
  investorProfile: SaveInvestorProfileInput;
  isInvestor: Scalars['Boolean'];
}>;


export type SaveMyProfileMutation = { __typename?: 'Mutation', saveSiteUser?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, email?: string | null } | null, saveCompanyProfile?: { __typename?: 'CompanyProfile', id: string, websiteUrl: string, description: string, name: string, phoneNumber: string, address: { __typename?: 'Address', city: string, country: string, usState?: string | null }, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, investmentCategory?: { __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName, displayName: string } | null, investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName, displayName: string }>, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }> | null, logo?: { __typename?: 'ApiFile', id: string, key: string } | null } | null, saveInvestorProfile?: { __typename?: 'InvestorProfile', id: string, canLeadInvestments: boolean, checkSizeMinDollars?: number | null, checkSizeMaxDollars?: number | null, isVerifiedInvestor: boolean } | null };

export type TopLevelDetailsSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type TopLevelDetailsSectionQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, email?: string | null, investorProfile?: { __typename?: 'InvestorProfile', id: string, checkSizeMinDollars?: number | null, checkSizeMaxDollars?: number | null } | null, companyProfile?: { __typename?: 'CompanyProfile', id: string, name: string, phoneNumber: string, websiteUrl: string, description: string, logo?: { __typename?: 'ApiFile', id: string, key: string } | null, address: { __typename?: 'Address', city: string, usState?: string | null, country: string }, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }> | null, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName, displayName: string }> } | null } | null };

export type PitchDeckTemplateActivityQueryVariables = Exact<{
  input: SlideQueryInput;
  includeSlide: Scalars['Boolean'];
}>;


export type PitchDeckTemplateActivityQuery = { __typename?: 'Query', slides: Array<{ __typename?: 'Slide', id: string, title: string, slideGroup: { __typename?: 'SlideGroup', id: string, name: SlideGroupName, displayName: string }, thumbnail: { __typename?: 'ApiFile', id: string, key: string, fileName: string }, slide?: { __typename?: 'ApiFile', id: string, key: string, fileName: string } }> };

export type PitchDeckTopicSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type PitchDeckTopicSectionQuery = { __typename?: 'Query', pitchDeckTopics: Array<{ __typename?: 'PitchDeckTopic', id: string, title: string, bodyText: string }> };

export type PitchDesignSectionQueryVariables = Exact<{
  input?: InputMaybe<SlideQueryInput>;
}>;


export type PitchDesignSectionQuery = { __typename?: 'Query', slides: Array<{ __typename?: 'Slide', id: string, title: string, slideGroup: { __typename?: 'SlideGroup', id: string, name: SlideGroupName, displayName: string }, thumbnail: { __typename?: 'ApiFile', id: string, key: string, fileName: string } }> };

export type ConfirmCodeActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfirmCodeActivityQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string } | null };

export type ConfirmCodeActivity_SaveSiteUserMutationVariables = Exact<{
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type ConfirmCodeActivity_SaveSiteUserMutation = { __typename?: 'Mutation', saveSiteUser?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string } | null };

export type CreateSubscriptionMutationVariables = Exact<{
  input: CreateSubscriptionInput;
}>;


export type CreateSubscriptionMutation = { __typename?: 'Mutation', createSubscription: { __typename?: 'SubscriptionSecrets', paymentIntentClientSecret: string, setupIntentClientSecret: string } };

export type OnboardingProfileActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingProfileActivityQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, activeAccessPass?: { __typename?: 'AccessPass', id: string, startDate: string, endDate: string } | null, type?: { __typename?: 'UserType', id: string, name: UserTypeName } | null, companyProfile?: { __typename?: 'CompanyProfile', id: string, name: string, websiteUrl: string, phoneNumber: string, description: string, logo?: { __typename?: 'ApiFile', id: string, key: string, fileName: string } | null, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string }>, investmentCategory?: { __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName } | null, investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName }>, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName }> | null, address: { __typename?: 'Address', city: string, country: string, usState?: string | null } } | null, investorProfile?: { __typename?: 'InvestorProfile', id: string, checkSizeMinDollars?: number | null, checkSizeMaxDollars?: number | null, canLeadInvestments: boolean, isVerifiedInvestor: boolean } | null } | null };

export type SaveOnboardingProfileMutationVariables = Exact<{
  companyProfile: SaveCompanyProfileInput;
  investorProfile: SaveInvestorProfileInput;
  isInvestor: Scalars['Boolean'];
}>;


export type SaveOnboardingProfileMutation = { __typename?: 'Mutation', saveCompanyProfile?: { __typename?: 'CompanyProfile', id: string, name: string, websiteUrl: string, phoneNumber: string, description: string, logo?: { __typename?: 'ApiFile', id: string, key: string, fileName: string } | null, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string }>, investmentCategory?: { __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName } | null, investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName }>, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName }> | null, address: { __typename?: 'Address', city: string, usState?: string | null, country: string } } | null, saveInvestorProfile?: { __typename?: 'InvestorProfile', id: string, checkSizeMinDollars?: number | null, checkSizeMaxDollars?: number | null, canLeadInvestments: boolean, isVerifiedInvestor: boolean } | null };

export type SaveUserTypeMutationVariables = Exact<{
  siteUserId: Scalars['ID'];
  type: UserTypeName;
}>;


export type SaveUserTypeMutation = { __typename?: 'Mutation', saveSiteUser?: { __typename?: 'SiteUserFull', id: string, type?: { __typename?: 'UserType', id: string, name: UserTypeName, displayName: string } | null } | null };

export type OnboardingUserTypeActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingUserTypeActivityQuery = { __typename?: 'Query', allAccessEnabled: boolean, loggedInUser?: { __typename?: 'SiteUserFull', id: string, type?: { __typename?: 'UserType', id: string, name: UserTypeName, displayName: string } | null } | null };

export type RegisterSiteUserMutationVariables = Exact<{
  input: RegisterSiteUserInput;
}>;


export type RegisterSiteUserMutation = { __typename?: 'Mutation', registerSiteUser?: { __typename?: 'SiteUserFull', id: string } | null };

export type SignUpActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type SignUpActivityQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string } | null };

export type SignUpActivity_SaveSiteUserMutationVariables = Exact<{
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type SignUpActivity_SaveSiteUserMutation = { __typename?: 'Mutation', saveSiteUser?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string } | null };

export type VerifyEmailNotInUseQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type VerifyEmailNotInUseQuery = { __typename?: 'Query', verifyEmailNotInUse: boolean };

export type AccessPassesTabPaneQueryVariables = Exact<{
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type AccessPassesTabPaneQuery = { __typename?: 'Query', accessPasses: { __typename?: 'AccessPassPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'AccessPass', id: string, email: string, note: string, startDate: string, endDate: string }> } };

export type AppSettingsTabPaneQueryVariables = Exact<{ [key: string]: never; }>;


export type AppSettingsTabPaneQuery = { __typename?: 'Query', allAccessEnabled: boolean };

export type ToggleAllAccessMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
}>;


export type ToggleAllAccessMutation = { __typename?: 'Mutation', toggleAllAccess: boolean };

export type DeleteInvestmentAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteInvestmentAreaMutation = { __typename?: 'Mutation', deleteInvestmentArea: boolean };

export type InvestmentAreasTabPaneQueryVariables = Exact<{ [key: string]: never; }>;


export type InvestmentAreasTabPaneQuery = { __typename?: 'Query', investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }> };

export type DeleteUsersMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteUsersMutation = { __typename?: 'Mutation', deleteUsers: boolean };

export type InvestorsTabPaneQueryVariables = Exact<{
  paginationInput: PaginationInput;
}>;


export type InvestorsTabPaneQuery = { __typename?: 'Query', investmentCategories: Array<{ __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName, displayName: string }>, users: { __typename?: 'SiteUserFullPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'SiteUserFull', id: string, createdTimestamp: string, isClaimed: boolean, firstName: string, lastName: string, email?: string | null, companyProfile?: { __typename?: 'CompanyProfile', id: string, isVisible: boolean, name: string, phoneNumber: string, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }> | null } | null, investorProfile?: { __typename?: 'InvestorProfile', id: string, isVerifiedInvestor: boolean } | null }> } };

export type UpdateCompanyProfileVisibilityMutationVariables = Exact<{
  input: UpdateCompanyProfileVisibilityInput;
}>;


export type UpdateCompanyProfileVisibilityMutation = { __typename?: 'Mutation', updateCompanyProfileVisibility?: { __typename?: 'CompanyProfile', id: string, isVisible: boolean } | null };

export type VerifyInvestorMutationVariables = Exact<{
  investorId: Scalars['ID'];
}>;


export type VerifyInvestorMutation = { __typename?: 'Mutation', saveInvestorProfile?: { __typename?: 'InvestorProfile', id: string, isVerifiedInvestor: boolean } | null };

export type StartupsTabPaneQueryVariables = Exact<{
  paginationInput: PaginationInput;
}>;


export type StartupsTabPaneQuery = { __typename?: 'Query', users: { __typename?: 'SiteUserFullPage', pageInfo: { __typename?: 'PageInfo', nextPage?: any | null, pages: Array<any>, previousPage?: any | null, totalRows: number }, nodes: Array<{ __typename?: 'SiteUserFull', id: string, createdTimestamp: string, isClaimed: boolean, firstName: string, lastName: string, email?: string | null, companyProfile?: { __typename?: 'CompanyProfile', id: string, name: string, phoneNumber: string, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }> | null } | null }> } };

export type SaveAdminProfileMutationVariables = Exact<{
  input: SaveSiteUserInput;
}>;


export type SaveAdminProfileMutation = { __typename?: 'Mutation', saveSiteUser?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, email?: string | null } | null };

export type SuperAdminUserProfileActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperAdminUserProfileActivityQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, email?: string | null } | null };

export type AllAccessWallQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAccessWallQuery = { __typename?: 'Query', allAccessEnabled: boolean };

export type CancelSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionMutation = { __typename?: 'Mutation', cancelSubscription?: { __typename?: 'SiteUserFull', id: string, subscriptionInfo?: { __typename?: 'SubscriptionInfo', id: string, status: StripeSubscriptionStatus, willCancelAtPeriodEnd: boolean, currentPeriodEnd: string } | null } | null };

export type CancelSubscriptionModalQueryVariables = Exact<{ [key: string]: never; }>;


export type CancelSubscriptionModalQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, subscriptionInfo?: { __typename?: 'SubscriptionInfo', id: string, status: StripeSubscriptionStatus, willCancelAtPeriodEnd: boolean, currentPeriodEnd: string } | null } | null };

export type DeleteLoggedInUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteLoggedInUserMutation = { __typename?: 'Mutation', deleteLoggedInUser: boolean };

export type DownloadsRemainingQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadsRemainingQuery = { __typename?: 'Query', allAccessEnabled: boolean, loggedInUser?: { __typename?: 'SiteUserFull', id: string, downloadsAllowed: number, downloadUsageForCycle: number, subscriptionInfo?: { __typename?: 'SubscriptionInfo', status: StripeSubscriptionStatus } | null } | null };

export type FavoriteInvestorMutationVariables = Exact<{
  input: FavoriteInvestorInput;
}>;


export type FavoriteInvestorMutation = { __typename?: 'Mutation', favoriteInvestor: boolean };

export type UserAccountButtonQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAccountButtonQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean, firstName: string, lastName: string } | null };

export type BeginSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type BeginSubscriptionQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, subscriptionInfo?: { __typename?: 'SubscriptionInfo', status: StripeSubscriptionStatus, currentPeriodEnd: string } | null } | null };

export type EndTrialEarlyMutationVariables = Exact<{ [key: string]: never; }>;


export type EndTrialEarlyMutation = { __typename?: 'Mutation', endTrialEarly: boolean };

export type LegalDocumentsQueryVariables = Exact<{
  extension?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type LegalDocumentsQuery = { __typename?: 'Query', legalDocuments: Array<{ __typename?: 'LegalDocument', id: string, title: string, extension: string, file: { __typename?: 'ApiFile', id: string, key: string, fileName: string } }> };

export type AuthWrapperQueryVariables = Exact<{ [key: string]: never; }>;


export type AuthWrapperQuery = { __typename?: 'Query', allAccessEnabled: boolean, loggedInUser?: { __typename?: 'SiteUserFull', id: string, isSuperAdmin: boolean, subscriptionStatus: SubscriptionStatusName, type?: { __typename?: 'UserType', id: string, name: UserTypeName, displayName: string } | null, companyProfile?: { __typename?: 'CompanyProfile', id: string } | null, activeAccessPass?: { __typename?: 'AccessPass', id: string, startDate: string, endDate: string } | null } | null };

export type BaseOnboardingTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type BaseOnboardingTemplateQuery = { __typename?: 'Query', allAccessEnabled: boolean };

export type AllEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllEnumsQuery = { __typename?: 'Query', investmentCategories: Array<{ __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName, displayName: string }>, investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName, displayName: string, parentName?: InvestmentGeographyName | null, ranking: number }>, investmentStages: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }>, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, usStates: Array<{ __typename?: 'USState', id: string, displayName: string }>, fundingStages: Array<{ __typename?: 'FundingStage', id: string, name: FundingStageName, displayName: string }> };

export type FundingStageSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type FundingStageSelectFieldQuery = { __typename?: 'Query', fundingStages: Array<{ __typename?: 'FundingStage', id: string, name: FundingStageName, displayName: string }> };

export type InvestmentAreaSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type InvestmentAreaSelectFieldQuery = { __typename?: 'Query', investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }> };

export type InvestmentCategorySelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type InvestmentCategorySelectFieldQuery = { __typename?: 'Query', investmentCategories: Array<{ __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName, displayName: string }> };

export type InvestmentGeographySelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type InvestmentGeographySelectFieldQuery = { __typename?: 'Query', investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName, displayName: string, parentName?: InvestmentGeographyName | null, ranking: number }> };

export type InvestmentStageSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type InvestmentStageSelectFieldQuery = { __typename?: 'Query', investmentStages: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }> };

export type UsStateSelectFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type UsStateSelectFieldQuery = { __typename?: 'Query', usStates: Array<{ __typename?: 'USState', id: string, displayName: string }> };

export type InviteSuperAdminMutationVariables = Exact<{
  input: InviteSuperAdminInput;
}>;


export type InviteSuperAdminMutation = { __typename?: 'Mutation', inviteSuperAdmin?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, isSuperAdmin: boolean } | null };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'SiteUserFull', id: string, email?: string | null, isClaimed: boolean } | null };

export type EditAccessPassModalQueryVariables = Exact<{
  accessPassId: Scalars['ID'];
}>;


export type EditAccessPassModalQuery = { __typename?: 'Query', accessPass?: { __typename?: 'AccessPass', id: string, email: string, note: string, startDate: string, endDate: string } | null };

export type SaveAccessPassMutationVariables = Exact<{
  input: SaveAccessPassInput;
}>;


export type SaveAccessPassMutation = { __typename?: 'Mutation', saveAccessPass?: { __typename?: 'AccessPass', id: string, email: string, note: string, startDate: string, endDate: string } | null };

export type OverrideActorStageDisplayNameMutationVariables = Exact<{
  input: OverrideActorStageDisplayNameInput;
}>;


export type OverrideActorStageDisplayNameMutation = { __typename?: 'Mutation', overrideActorStageDisplayName: { __typename?: 'ActorStage', id: string, name: ActorStageName, displayName: string, overrideDisplayName?: string | null } };

export type EditInvestmentAreaModalQueryVariables = Exact<{
  investmentAreaId: Scalars['ID'];
}>;


export type EditInvestmentAreaModalQuery = { __typename?: 'Query', investmentArea?: { __typename?: 'InvestmentArea', id: string, displayName: string } | null };

export type SaveInvestmentAreaMutationVariables = Exact<{
  input: SaveInvestmentAreaInput;
}>;


export type SaveInvestmentAreaMutation = { __typename?: 'Mutation', saveInvestmentArea?: { __typename?: 'InvestmentArea', id: string, displayName: string } | null };

export type EditInvestorCardModalQueryVariables = Exact<{
  investorCardId: Scalars['ID'];
}>;


export type EditInvestorCardModalQuery = { __typename?: 'Query', investorCard?: { __typename?: 'InvestorCard', id: string, displayName: string, potentialInvestmentAmountDollars: number, investorProfile?: { __typename?: 'InvestorProfile', id: string } | null } | null };

export type SaveUserProfileMutationVariables = Exact<{
  userInput: SaveSiteUserInput;
  companyProfileInput: SaveCompanyProfileInput;
  investorProfile: SaveInvestorProfileInput;
  isInvestor: Scalars['Boolean'];
}>;


export type SaveUserProfileMutation = { __typename?: 'Mutation', saveSiteUser?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, email?: string | null } | null, saveCompanyProfile?: { __typename?: 'CompanyProfile', id: string, name: string, websiteUrl: string, description: string, phoneNumber: string, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, investmentCategory?: { __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName, displayName: string } | null, investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName, displayName: string }>, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }> | null, logo?: { __typename?: 'ApiFile', id: string, key: string } | null, address: { __typename?: 'Address', city: string, usState?: string | null, country: string } } | null, saveInvestorProfile?: { __typename?: 'InvestorProfile', id: string, checkSizeMinDollars?: number | null, checkSizeMaxDollars?: number | null, canLeadInvestments: boolean, isVerifiedInvestor: boolean } | null };

export type EditUserModalQueryVariables = Exact<{
  id: Scalars['ID'];
  isInvestor: Scalars['Boolean'];
}>;


export type EditUserModalQuery = { __typename?: 'Query', user?: { __typename?: 'SiteUserFull', id: string, firstName: string, lastName: string, email?: string | null, companyProfile?: { __typename?: 'CompanyProfile', id: string, name: string, websiteUrl: string, description: string, phoneNumber: string, logo?: { __typename?: 'ApiFile', id: string, key: string, fileName: string } | null, investmentStages?: Array<{ __typename?: 'InvestmentStage', id: string, name: InvestmentStageName, displayName: string }> | null, investmentCategory?: { __typename?: 'InvestmentCategory', id: string, name: InvestmentCategoryName, displayName: string } | null, investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, investmentGeographies?: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName }>, address: { __typename?: 'Address', city: string, usState?: string | null, country: string } } | null, investorProfile?: { __typename?: 'InvestorProfile', id: string, canLeadInvestments: boolean, checkSizeMinDollars?: number | null, checkSizeMaxDollars?: number | null, isVerifiedInvestor: boolean } | null } | null };

export type FundraisingCampaignModalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type FundraisingCampaignModalQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, name: string, description: string, targetCloseDate?: string | null, targetAmountDollars: number, fundingStage: { __typename?: 'FundingStage', id: string, name: FundingStageName, displayName: string } } | null };

export type SaveCampaignMutationVariables = Exact<{
  input: SaveCampaignInput;
}>;


export type SaveCampaignMutation = { __typename?: 'Mutation', saveCampaign: { __typename?: 'Campaign', id: string, name: string, description: string, targetCloseDate?: string | null, targetAmountDollars: number, fundingStage: { __typename?: 'FundingStage', id: string, name: FundingStageName, displayName: string } } };

export type LegalTermDetailQueryVariables = Exact<{
  title: Scalars['String'];
}>;


export type LegalTermDetailQuery = { __typename?: 'Query', legalTermDetail?: { __typename?: 'LegalTermDetail', id: string, title: string, description: string, semantics: string, illustrativeWording: string, whatsTypical: string, whereElseToCheckInTermSheet: string, scenarioModeling: string, whereToFindInFullDocs: string } | null };

export type ManageDownloadLimitsModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ManageDownloadLimitsModalQuery = { __typename?: 'Query', downloadLimitSettings: Array<{ __typename?: 'DownloadLimitSetting', id: string, limit: number, category: { __typename?: 'DownloadLimitCategory', id: string, name: DownloadLimitCategoryName, displayName: string } }> };

export type SaveDownloadLimitSettingMutationVariables = Exact<{
  categoryName: DownloadLimitCategoryName;
  limit: Scalars['Int'];
}>;


export type SaveDownloadLimitSettingMutation = { __typename?: 'Mutation', saveDownloadLimitSetting?: { __typename?: 'DownloadLimitSetting', id: string, limit: number } | null };

export type PitchDeckTopicDetailQueryVariables = Exact<{
  title: Scalars['String'];
}>;


export type PitchDeckTopicDetailQuery = { __typename?: 'Query', pitchDeckTopicDetail?: { __typename?: 'PitchDeckTopicDetail', id: string, title: string, description: string, whyIsThisImportant: string, whatYouWillNeed: string, potentialPitfalls: string, commonSuccesses: string, closingThoughts: string } | null };

export type SaveNoteMutationVariables = Exact<{
  input: SaveNoteInput;
}>;


export type SaveNoteMutation = { __typename?: 'Mutation', saveNote: { __typename?: 'Note', id: string, title: string, body: string } };

export type SaveNoteModalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SaveNoteModalQuery = { __typename?: 'Query', note: { __typename?: 'Note', id: string, title: string, body: string } };

export type BulkImportInvestmentAreasMutationVariables = Exact<{
  input: BulkImportInvestmentAreasInput;
}>;


export type BulkImportInvestmentAreasMutation = { __typename?: 'Mutation', bulkImportInvestmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }> };

export type BulkImportUsersMutationVariables = Exact<{
  input: BulkImportUsersInput;
}>;


export type BulkImportUsersMutation = { __typename?: 'Mutation', bulkImportUsers: Array<{ __typename?: 'SiteUserFull', id: string }> };

export type UploadUsersModalQueryVariables = Exact<{ [key: string]: never; }>;


export type UploadUsersModalQuery = { __typename?: 'Query', investmentAreas: Array<{ __typename?: 'InvestmentArea', id: string, displayName: string }>, investmentGeographies: Array<{ __typename?: 'InvestmentGeography', id: string, name: InvestmentGeographyName, parentName?: InvestmentGeographyName | null }> };

export type ValidateEmailsAvailableQueryVariables = Exact<{
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type ValidateEmailsAvailableQuery = { __typename?: 'Query', validateEmailsAvailable?: Array<string> | null };

export type RestrictToSubscriptionProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type RestrictToSubscriptionProviderQuery = { __typename?: 'Query', loggedInUser?: { __typename?: 'SiteUserFull', id: string, subscriptionStatus: SubscriptionStatusName } | null };


export const DebugActivityDocument = gql`
    query DebugActivity {
  version
  users {
    nodes {
      id
      firstName
      lastName
      email
      type {
        id
        displayName
      }
    }
  }
}
    `;

/**
 * __useDebugActivityQuery__
 *
 * To run a query within a React component, call `useDebugActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebugActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebugActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useDebugActivityQuery(baseOptions?: Apollo.QueryHookOptions<DebugActivityQuery, DebugActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DebugActivityQuery, DebugActivityQueryVariables>(DebugActivityDocument, options);
      }
export function useDebugActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DebugActivityQuery, DebugActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DebugActivityQuery, DebugActivityQueryVariables>(DebugActivityDocument, options);
        }
export type DebugActivityQueryHookResult = ReturnType<typeof useDebugActivityQuery>;
export type DebugActivityLazyQueryHookResult = ReturnType<typeof useDebugActivityLazyQuery>;
export type DebugActivityQueryResult = Apollo.QueryResult<DebugActivityQuery, DebugActivityQueryVariables>;
export const DeleteCampaignDocument = gql`
    mutation DeleteCampaign($id: ID!) {
  deleteCampaign(id: $id)
}
    `;
export type DeleteCampaignMutationFn = Apollo.MutationFunction<DeleteCampaignMutation, DeleteCampaignMutationVariables>;

/**
 * __useDeleteCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignMutation, { data, loading, error }] = useDeleteCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCampaignMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignMutation, DeleteCampaignMutationVariables>(DeleteCampaignDocument, options);
      }
export type DeleteCampaignMutationHookResult = ReturnType<typeof useDeleteCampaignMutation>;
export type DeleteCampaignMutationResult = Apollo.MutationResult<DeleteCampaignMutation>;
export type DeleteCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignMutation, DeleteCampaignMutationVariables>;
export const FundraiseActivityDocument = gql`
    query FundraiseActivity($id: ID!) {
  favoritedInvestors {
    id
    investorProfile {
      id
    }
    companyProfile {
      id
      name
    }
  }
  campaign(id: $id) {
    id
    name
    description
    amountRaisedDollars
    targetAmountDollars
    targetCloseDate
    completedAt
    investorCards {
      id
      displayName
      potentialInvestmentAmountDollars
      stage {
        id
        name
      }
      investorProfile {
        id
      }
      notes {
        id
        title
        body
      }
    }
    fundingStage {
      id
      name
      displayName
    }
  }
  actorStages {
    id
    name
    displayName
    overrideDisplayName
  }
}
    `;

/**
 * __useFundraiseActivityQuery__
 *
 * To run a query within a React component, call `useFundraiseActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundraiseActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundraiseActivityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFundraiseActivityQuery(baseOptions: Apollo.QueryHookOptions<FundraiseActivityQuery, FundraiseActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundraiseActivityQuery, FundraiseActivityQueryVariables>(FundraiseActivityDocument, options);
      }
export function useFundraiseActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundraiseActivityQuery, FundraiseActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundraiseActivityQuery, FundraiseActivityQueryVariables>(FundraiseActivityDocument, options);
        }
export type FundraiseActivityQueryHookResult = ReturnType<typeof useFundraiseActivityQuery>;
export type FundraiseActivityLazyQueryHookResult = ReturnType<typeof useFundraiseActivityLazyQuery>;
export type FundraiseActivityQueryResult = Apollo.QueryResult<FundraiseActivityQuery, FundraiseActivityQueryVariables>;
export const DeleteNoteDocument = gql`
    mutation DeleteNote($id: ID!) {
  deleteNote(id: $id)
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const MarkCampaignCompleteDocument = gql`
    mutation MarkCampaignComplete($id: ID!) {
  markCampaignComplete(id: $id)
}
    `;
export type MarkCampaignCompleteMutationFn = Apollo.MutationFunction<MarkCampaignCompleteMutation, MarkCampaignCompleteMutationVariables>;

/**
 * __useMarkCampaignCompleteMutation__
 *
 * To run a mutation, you first call `useMarkCampaignCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCampaignCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCampaignCompleteMutation, { data, loading, error }] = useMarkCampaignCompleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkCampaignCompleteMutation(baseOptions?: Apollo.MutationHookOptions<MarkCampaignCompleteMutation, MarkCampaignCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCampaignCompleteMutation, MarkCampaignCompleteMutationVariables>(MarkCampaignCompleteDocument, options);
      }
export type MarkCampaignCompleteMutationHookResult = ReturnType<typeof useMarkCampaignCompleteMutation>;
export type MarkCampaignCompleteMutationResult = Apollo.MutationResult<MarkCampaignCompleteMutation>;
export type MarkCampaignCompleteMutationOptions = Apollo.BaseMutationOptions<MarkCampaignCompleteMutation, MarkCampaignCompleteMutationVariables>;
export const ReopenCampaignDocument = gql`
    mutation ReopenCampaign($id: ID!) {
  reopenCampaign(id: $id)
}
    `;
export type ReopenCampaignMutationFn = Apollo.MutationFunction<ReopenCampaignMutation, ReopenCampaignMutationVariables>;

/**
 * __useReopenCampaignMutation__
 *
 * To run a mutation, you first call `useReopenCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenCampaignMutation, { data, loading, error }] = useReopenCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReopenCampaignMutation(baseOptions?: Apollo.MutationHookOptions<ReopenCampaignMutation, ReopenCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenCampaignMutation, ReopenCampaignMutationVariables>(ReopenCampaignDocument, options);
      }
export type ReopenCampaignMutationHookResult = ReturnType<typeof useReopenCampaignMutation>;
export type ReopenCampaignMutationResult = Apollo.MutationResult<ReopenCampaignMutation>;
export type ReopenCampaignMutationOptions = Apollo.BaseMutationOptions<ReopenCampaignMutation, ReopenCampaignMutationVariables>;
export const SaveInvestorCardDocument = gql`
    mutation SaveInvestorCard($input: SaveInvestorCardInput!) {
  saveInvestorCard(input: $input) {
    id
    displayName
    investorProfile {
      id
    }
    potentialInvestmentAmountDollars
    stage {
      id
      name
      displayName
    }
    campaign {
      id
      amountRaisedDollars
    }
  }
}
    `;
export type SaveInvestorCardMutationFn = Apollo.MutationFunction<SaveInvestorCardMutation, SaveInvestorCardMutationVariables>;

/**
 * __useSaveInvestorCardMutation__
 *
 * To run a mutation, you first call `useSaveInvestorCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInvestorCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInvestorCardMutation, { data, loading, error }] = useSaveInvestorCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveInvestorCardMutation(baseOptions?: Apollo.MutationHookOptions<SaveInvestorCardMutation, SaveInvestorCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInvestorCardMutation, SaveInvestorCardMutationVariables>(SaveInvestorCardDocument, options);
      }
export type SaveInvestorCardMutationHookResult = ReturnType<typeof useSaveInvestorCardMutation>;
export type SaveInvestorCardMutationResult = Apollo.MutationResult<SaveInvestorCardMutation>;
export type SaveInvestorCardMutationOptions = Apollo.BaseMutationOptions<SaveInvestorCardMutation, SaveInvestorCardMutationVariables>;
export const HomeActivityDocument = gql`
    query HomeActivity {
  loggedInUser {
    id
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useHomeActivityQuery__
 *
 * To run a query within a React component, call `useHomeActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeActivityQuery(baseOptions?: Apollo.QueryHookOptions<HomeActivityQuery, HomeActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeActivityQuery, HomeActivityQueryVariables>(HomeActivityDocument, options);
      }
export function useHomeActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeActivityQuery, HomeActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeActivityQuery, HomeActivityQueryVariables>(HomeActivityDocument, options);
        }
export type HomeActivityQueryHookResult = ReturnType<typeof useHomeActivityQuery>;
export type HomeActivityLazyQueryHookResult = ReturnType<typeof useHomeActivityLazyQuery>;
export type HomeActivityQueryResult = Apollo.QueryResult<HomeActivityQuery, HomeActivityQueryVariables>;
export const InvestorProfileActivityDocument = gql`
    query InvestorProfileActivity($userId: ID!) {
  favoritedInvestors {
    id
  }
  user(id: $userId) {
    id
    companyProfile {
      id
      name
      description
      websiteUrl
      logo {
        id
        key
      }
      address {
        city
        usState
        country
      }
      investmentCategory {
        id
        name
        displayName
      }
      investmentStages {
        id
        name
        displayName
      }
      investmentAreas {
        id
        displayName
      }
      investmentGeographies {
        id
        name
        displayName
      }
    }
    investorProfile {
      id
      canLeadInvestments
      checkSizeMinDollars
      checkSizeMaxDollars
      isVerifiedInvestor
    }
  }
}
    `;

/**
 * __useInvestorProfileActivityQuery__
 *
 * To run a query within a React component, call `useInvestorProfileActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorProfileActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorProfileActivityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInvestorProfileActivityQuery(baseOptions: Apollo.QueryHookOptions<InvestorProfileActivityQuery, InvestorProfileActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorProfileActivityQuery, InvestorProfileActivityQueryVariables>(InvestorProfileActivityDocument, options);
      }
export function useInvestorProfileActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorProfileActivityQuery, InvestorProfileActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorProfileActivityQuery, InvestorProfileActivityQueryVariables>(InvestorProfileActivityDocument, options);
        }
export type InvestorProfileActivityQueryHookResult = ReturnType<typeof useInvestorProfileActivityQuery>;
export type InvestorProfileActivityLazyQueryHookResult = ReturnType<typeof useInvestorProfileActivityLazyQuery>;
export type InvestorProfileActivityQueryResult = Apollo.QueryResult<InvestorProfileActivityQuery, InvestorProfileActivityQueryVariables>;
export const InvestorsActivityDocument = gql`
    query InvestorsActivity($page: Cursor, $filter: UsersFilterInput, $sort: UsersSortInput) {
  favoritedInvestors {
    id
  }
  users(
    paginationInput: {after: $page, first: 30}
    filterInput: $filter
    sortInput: $sort
  ) {
    pageInfo {
      nextPage
      pages
      previousPage
      totalRows
    }
    nodes {
      id
      companyProfile {
        id
        name
        websiteUrl
        description
        logo {
          id
          key
        }
      }
    }
  }
}
    `;

/**
 * __useInvestorsActivityQuery__
 *
 * To run a query within a React component, call `useInvestorsActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorsActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorsActivityQuery({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useInvestorsActivityQuery(baseOptions?: Apollo.QueryHookOptions<InvestorsActivityQuery, InvestorsActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorsActivityQuery, InvestorsActivityQueryVariables>(InvestorsActivityDocument, options);
      }
export function useInvestorsActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorsActivityQuery, InvestorsActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorsActivityQuery, InvestorsActivityQueryVariables>(InvestorsActivityDocument, options);
        }
export type InvestorsActivityQueryHookResult = ReturnType<typeof useInvestorsActivityQuery>;
export type InvestorsActivityLazyQueryHookResult = ReturnType<typeof useInvestorsActivityLazyQuery>;
export type InvestorsActivityQueryResult = Apollo.QueryResult<InvestorsActivityQuery, InvestorsActivityQueryVariables>;
export const LegalTermsDocument = gql`
    query LegalTerms {
  legalTerms {
    id
    title
    bodyText
    investmentOption {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useLegalTermsQuery__
 *
 * To run a query within a React component, call `useLegalTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLegalTermsQuery(baseOptions?: Apollo.QueryHookOptions<LegalTermsQuery, LegalTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalTermsQuery, LegalTermsQueryVariables>(LegalTermsDocument, options);
      }
export function useLegalTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalTermsQuery, LegalTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalTermsQuery, LegalTermsQueryVariables>(LegalTermsDocument, options);
        }
export type LegalTermsQueryHookResult = ReturnType<typeof useLegalTermsQuery>;
export type LegalTermsLazyQueryHookResult = ReturnType<typeof useLegalTermsLazyQuery>;
export type LegalTermsQueryResult = Apollo.QueryResult<LegalTermsQuery, LegalTermsQueryVariables>;
export const MyFundraisesActivityDocument = gql`
    query MyFundraisesActivity {
  myCampaigns {
    id
    name
    creationDate
    targetCloseDate
    amountRaisedDollars
    targetAmountDollars
    completedAt
    fundingStage {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useMyFundraisesActivityQuery__
 *
 * To run a query within a React component, call `useMyFundraisesActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFundraisesActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFundraisesActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyFundraisesActivityQuery(baseOptions?: Apollo.QueryHookOptions<MyFundraisesActivityQuery, MyFundraisesActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyFundraisesActivityQuery, MyFundraisesActivityQueryVariables>(MyFundraisesActivityDocument, options);
      }
export function useMyFundraisesActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyFundraisesActivityQuery, MyFundraisesActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyFundraisesActivityQuery, MyFundraisesActivityQueryVariables>(MyFundraisesActivityDocument, options);
        }
export type MyFundraisesActivityQueryHookResult = ReturnType<typeof useMyFundraisesActivityQuery>;
export type MyFundraisesActivityLazyQueryHookResult = ReturnType<typeof useMyFundraisesActivityLazyQuery>;
export type MyFundraisesActivityQueryResult = Apollo.QueryResult<MyFundraisesActivityQuery, MyFundraisesActivityQueryVariables>;
export const EditPaymentSectionDocument = gql`
    query EditPaymentSection {
  loggedInUser {
    id
    paymentInfo {
      id
      country
      usState
      city
      address
      zipCode
    }
  }
}
    `;

/**
 * __useEditPaymentSectionQuery__
 *
 * To run a query within a React component, call `useEditPaymentSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditPaymentSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditPaymentSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditPaymentSectionQuery(baseOptions?: Apollo.QueryHookOptions<EditPaymentSectionQuery, EditPaymentSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditPaymentSectionQuery, EditPaymentSectionQueryVariables>(EditPaymentSectionDocument, options);
      }
export function useEditPaymentSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditPaymentSectionQuery, EditPaymentSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditPaymentSectionQuery, EditPaymentSectionQueryVariables>(EditPaymentSectionDocument, options);
        }
export type EditPaymentSectionQueryHookResult = ReturnType<typeof useEditPaymentSectionQuery>;
export type EditPaymentSectionLazyQueryHookResult = ReturnType<typeof useEditPaymentSectionLazyQuery>;
export type EditPaymentSectionQueryResult = Apollo.QueryResult<EditPaymentSectionQuery, EditPaymentSectionQueryVariables>;
export const UpdatePaymentInfoDocument = gql`
    mutation UpdatePaymentInfo($input: UpdatePaymentInfoInput!) {
  updatePaymentInfo(input: $input) {
    id
    address
    city
    country
    usState
    zipCode
  }
}
    `;
export type UpdatePaymentInfoMutationFn = Apollo.MutationFunction<UpdatePaymentInfoMutation, UpdatePaymentInfoMutationVariables>;

/**
 * __useUpdatePaymentInfoMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentInfoMutation, { data, loading, error }] = useUpdatePaymentInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePaymentInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentInfoMutation, UpdatePaymentInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentInfoMutation, UpdatePaymentInfoMutationVariables>(UpdatePaymentInfoDocument, options);
      }
export type UpdatePaymentInfoMutationHookResult = ReturnType<typeof useUpdatePaymentInfoMutation>;
export type UpdatePaymentInfoMutationResult = Apollo.MutationResult<UpdatePaymentInfoMutation>;
export type UpdatePaymentInfoMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentInfoMutation, UpdatePaymentInfoMutationVariables>;
export const EditProfileSectionDocument = gql`
    query EditProfileSection {
  loggedInUser {
    id
    firstName
    lastName
    email
    type {
      id
      name
      displayName
    }
    companyProfile {
      id
      websiteUrl
      name
      phoneNumber
      description
      address {
        city
        usState
        country
      }
      investmentCategory {
        id
        name
        displayName
      }
      investmentAreas {
        id
        displayName
      }
      investmentStages {
        id
        name
        displayName
      }
      investmentGeographies {
        id
        name
        displayName
      }
    }
    investorProfile {
      id
      checkSizeMinDollars
      checkSizeMaxDollars
    }
  }
}
    `;

/**
 * __useEditProfileSectionQuery__
 *
 * To run a query within a React component, call `useEditProfileSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditProfileSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditProfileSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useEditProfileSectionQuery(baseOptions?: Apollo.QueryHookOptions<EditProfileSectionQuery, EditProfileSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditProfileSectionQuery, EditProfileSectionQueryVariables>(EditProfileSectionDocument, options);
      }
export function useEditProfileSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditProfileSectionQuery, EditProfileSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditProfileSectionQuery, EditProfileSectionQueryVariables>(EditProfileSectionDocument, options);
        }
export type EditProfileSectionQueryHookResult = ReturnType<typeof useEditProfileSectionQuery>;
export type EditProfileSectionLazyQueryHookResult = ReturnType<typeof useEditProfileSectionLazyQuery>;
export type EditProfileSectionQueryResult = Apollo.QueryResult<EditProfileSectionQuery, EditProfileSectionQueryVariables>;
export const SaveMyProfileDocument = gql`
    mutation SaveMyProfile($input: SaveSiteUserInput!, $profileInput: SaveCompanyProfileInput!, $investorProfile: SaveInvestorProfileInput!, $isInvestor: Boolean!) {
  saveSiteUser(input: $input) {
    id
    firstName
    lastName
    email
  }
  saveCompanyProfile(input: $profileInput) {
    id
    address {
      city
      country
      usState
    }
    websiteUrl
    description
    investmentAreas {
      id
      displayName
    }
    investmentCategory {
      id
      name
      displayName
    }
    investmentGeographies {
      id
      name
      displayName
    }
    investmentStages {
      id
      name
      displayName
    }
    logo {
      id
      key
    }
    name
    phoneNumber
  }
  saveInvestorProfile(input: $investorProfile) @include(if: $isInvestor) {
    id
    canLeadInvestments
    checkSizeMinDollars
    checkSizeMaxDollars
    isVerifiedInvestor
  }
}
    `;
export type SaveMyProfileMutationFn = Apollo.MutationFunction<SaveMyProfileMutation, SaveMyProfileMutationVariables>;

/**
 * __useSaveMyProfileMutation__
 *
 * To run a mutation, you first call `useSaveMyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMyProfileMutation, { data, loading, error }] = useSaveMyProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *      profileInput: // value for 'profileInput'
 *      investorProfile: // value for 'investorProfile'
 *      isInvestor: // value for 'isInvestor'
 *   },
 * });
 */
export function useSaveMyProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveMyProfileMutation, SaveMyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMyProfileMutation, SaveMyProfileMutationVariables>(SaveMyProfileDocument, options);
      }
export type SaveMyProfileMutationHookResult = ReturnType<typeof useSaveMyProfileMutation>;
export type SaveMyProfileMutationResult = Apollo.MutationResult<SaveMyProfileMutation>;
export type SaveMyProfileMutationOptions = Apollo.BaseMutationOptions<SaveMyProfileMutation, SaveMyProfileMutationVariables>;
export const TopLevelDetailsSectionDocument = gql`
    query TopLevelDetailsSection {
  loggedInUser {
    id
    firstName
    lastName
    email
    investorProfile {
      id
      checkSizeMinDollars
      checkSizeMaxDollars
    }
    companyProfile {
      id
      name
      logo {
        id
        key
      }
      phoneNumber
      websiteUrl
      description
      address {
        city
        usState
        country
      }
      investmentStages {
        id
        name
        displayName
      }
      investmentAreas {
        id
        displayName
      }
      investmentGeographies {
        id
        name
        displayName
      }
    }
    investorProfile {
      id
      checkSizeMinDollars
      checkSizeMaxDollars
    }
  }
}
    `;

/**
 * __useTopLevelDetailsSectionQuery__
 *
 * To run a query within a React component, call `useTopLevelDetailsSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopLevelDetailsSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopLevelDetailsSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopLevelDetailsSectionQuery(baseOptions?: Apollo.QueryHookOptions<TopLevelDetailsSectionQuery, TopLevelDetailsSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopLevelDetailsSectionQuery, TopLevelDetailsSectionQueryVariables>(TopLevelDetailsSectionDocument, options);
      }
export function useTopLevelDetailsSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopLevelDetailsSectionQuery, TopLevelDetailsSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopLevelDetailsSectionQuery, TopLevelDetailsSectionQueryVariables>(TopLevelDetailsSectionDocument, options);
        }
export type TopLevelDetailsSectionQueryHookResult = ReturnType<typeof useTopLevelDetailsSectionQuery>;
export type TopLevelDetailsSectionLazyQueryHookResult = ReturnType<typeof useTopLevelDetailsSectionLazyQuery>;
export type TopLevelDetailsSectionQueryResult = Apollo.QueryResult<TopLevelDetailsSectionQuery, TopLevelDetailsSectionQueryVariables>;
export const PitchDeckTemplateActivityDocument = gql`
    query PitchDeckTemplateActivity($input: SlideQueryInput!, $includeSlide: Boolean!) {
  slides(input: $input) {
    id
    slideGroup {
      id
      name
      displayName
    }
    title
    thumbnail {
      id
      key
      fileName
    }
    slide @include(if: $includeSlide) {
      id
      key
      fileName
    }
  }
}
    `;

/**
 * __usePitchDeckTemplateActivityQuery__
 *
 * To run a query within a React component, call `usePitchDeckTemplateActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchDeckTemplateActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchDeckTemplateActivityQuery({
 *   variables: {
 *      input: // value for 'input'
 *      includeSlide: // value for 'includeSlide'
 *   },
 * });
 */
export function usePitchDeckTemplateActivityQuery(baseOptions: Apollo.QueryHookOptions<PitchDeckTemplateActivityQuery, PitchDeckTemplateActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PitchDeckTemplateActivityQuery, PitchDeckTemplateActivityQueryVariables>(PitchDeckTemplateActivityDocument, options);
      }
export function usePitchDeckTemplateActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PitchDeckTemplateActivityQuery, PitchDeckTemplateActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PitchDeckTemplateActivityQuery, PitchDeckTemplateActivityQueryVariables>(PitchDeckTemplateActivityDocument, options);
        }
export type PitchDeckTemplateActivityQueryHookResult = ReturnType<typeof usePitchDeckTemplateActivityQuery>;
export type PitchDeckTemplateActivityLazyQueryHookResult = ReturnType<typeof usePitchDeckTemplateActivityLazyQuery>;
export type PitchDeckTemplateActivityQueryResult = Apollo.QueryResult<PitchDeckTemplateActivityQuery, PitchDeckTemplateActivityQueryVariables>;
export const PitchDeckTopicSectionDocument = gql`
    query PitchDeckTopicSection {
  pitchDeckTopics {
    id
    title
    bodyText
  }
}
    `;

/**
 * __usePitchDeckTopicSectionQuery__
 *
 * To run a query within a React component, call `usePitchDeckTopicSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchDeckTopicSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchDeckTopicSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePitchDeckTopicSectionQuery(baseOptions?: Apollo.QueryHookOptions<PitchDeckTopicSectionQuery, PitchDeckTopicSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PitchDeckTopicSectionQuery, PitchDeckTopicSectionQueryVariables>(PitchDeckTopicSectionDocument, options);
      }
export function usePitchDeckTopicSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PitchDeckTopicSectionQuery, PitchDeckTopicSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PitchDeckTopicSectionQuery, PitchDeckTopicSectionQueryVariables>(PitchDeckTopicSectionDocument, options);
        }
export type PitchDeckTopicSectionQueryHookResult = ReturnType<typeof usePitchDeckTopicSectionQuery>;
export type PitchDeckTopicSectionLazyQueryHookResult = ReturnType<typeof usePitchDeckTopicSectionLazyQuery>;
export type PitchDeckTopicSectionQueryResult = Apollo.QueryResult<PitchDeckTopicSectionQuery, PitchDeckTopicSectionQueryVariables>;
export const PitchDesignSectionDocument = gql`
    query PitchDesignSection($input: SlideQueryInput) {
  slides(input: $input) {
    id
    slideGroup {
      id
      name
      displayName
    }
    title
    thumbnail {
      id
      key
      fileName
    }
  }
}
    `;

/**
 * __usePitchDesignSectionQuery__
 *
 * To run a query within a React component, call `usePitchDesignSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchDesignSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchDesignSectionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePitchDesignSectionQuery(baseOptions?: Apollo.QueryHookOptions<PitchDesignSectionQuery, PitchDesignSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PitchDesignSectionQuery, PitchDesignSectionQueryVariables>(PitchDesignSectionDocument, options);
      }
export function usePitchDesignSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PitchDesignSectionQuery, PitchDesignSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PitchDesignSectionQuery, PitchDesignSectionQueryVariables>(PitchDesignSectionDocument, options);
        }
export type PitchDesignSectionQueryHookResult = ReturnType<typeof usePitchDesignSectionQuery>;
export type PitchDesignSectionLazyQueryHookResult = ReturnType<typeof usePitchDesignSectionLazyQuery>;
export type PitchDesignSectionQueryResult = Apollo.QueryResult<PitchDesignSectionQuery, PitchDesignSectionQueryVariables>;
export const ConfirmCodeActivityDocument = gql`
    query ConfirmCodeActivity {
  loggedInUser {
    id
  }
}
    `;

/**
 * __useConfirmCodeActivityQuery__
 *
 * To run a query within a React component, call `useConfirmCodeActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfirmCodeActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfirmCodeActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useConfirmCodeActivityQuery(baseOptions?: Apollo.QueryHookOptions<ConfirmCodeActivityQuery, ConfirmCodeActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfirmCodeActivityQuery, ConfirmCodeActivityQueryVariables>(ConfirmCodeActivityDocument, options);
      }
export function useConfirmCodeActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfirmCodeActivityQuery, ConfirmCodeActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfirmCodeActivityQuery, ConfirmCodeActivityQueryVariables>(ConfirmCodeActivityDocument, options);
        }
export type ConfirmCodeActivityQueryHookResult = ReturnType<typeof useConfirmCodeActivityQuery>;
export type ConfirmCodeActivityLazyQueryHookResult = ReturnType<typeof useConfirmCodeActivityLazyQuery>;
export type ConfirmCodeActivityQueryResult = Apollo.QueryResult<ConfirmCodeActivityQuery, ConfirmCodeActivityQueryVariables>;
export const ConfirmCodeActivity_SaveSiteUserDocument = gql`
    mutation ConfirmCodeActivity_SaveSiteUser($id: ID!, $firstName: String!, $lastName: String!) {
  saveSiteUser(input: {id: $id, firstName: $firstName, lastName: $lastName}) {
    id
    firstName
    lastName
  }
}
    `;
export type ConfirmCodeActivity_SaveSiteUserMutationFn = Apollo.MutationFunction<ConfirmCodeActivity_SaveSiteUserMutation, ConfirmCodeActivity_SaveSiteUserMutationVariables>;

/**
 * __useConfirmCodeActivity_SaveSiteUserMutation__
 *
 * To run a mutation, you first call `useConfirmCodeActivity_SaveSiteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCodeActivity_SaveSiteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCodeActivitySaveSiteUserMutation, { data, loading, error }] = useConfirmCodeActivity_SaveSiteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useConfirmCodeActivity_SaveSiteUserMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCodeActivity_SaveSiteUserMutation, ConfirmCodeActivity_SaveSiteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmCodeActivity_SaveSiteUserMutation, ConfirmCodeActivity_SaveSiteUserMutationVariables>(ConfirmCodeActivity_SaveSiteUserDocument, options);
      }
export type ConfirmCodeActivity_SaveSiteUserMutationHookResult = ReturnType<typeof useConfirmCodeActivity_SaveSiteUserMutation>;
export type ConfirmCodeActivity_SaveSiteUserMutationResult = Apollo.MutationResult<ConfirmCodeActivity_SaveSiteUserMutation>;
export type ConfirmCodeActivity_SaveSiteUserMutationOptions = Apollo.BaseMutationOptions<ConfirmCodeActivity_SaveSiteUserMutation, ConfirmCodeActivity_SaveSiteUserMutationVariables>;
export const CreateSubscriptionDocument = gql`
    mutation CreateSubscription($input: CreateSubscriptionInput!) {
  createSubscription(input: $input) {
    paymentIntentClientSecret
    setupIntentClientSecret
  }
}
    `;
export type CreateSubscriptionMutationFn = Apollo.MutationFunction<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;

/**
 * __useCreateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionMutation, { data, loading, error }] = useCreateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>(CreateSubscriptionDocument, options);
      }
export type CreateSubscriptionMutationHookResult = ReturnType<typeof useCreateSubscriptionMutation>;
export type CreateSubscriptionMutationResult = Apollo.MutationResult<CreateSubscriptionMutation>;
export type CreateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>;
export const OnboardingProfileActivityDocument = gql`
    query OnboardingProfileActivity {
  loggedInUser {
    id
    activeAccessPass {
      id
      startDate
      endDate
    }
    type {
      id
      name
    }
    companyProfile {
      id
      name
      logo {
        id
        key
        fileName
      }
      websiteUrl
      phoneNumber
      description
      investmentAreas {
        id
      }
      investmentCategory {
        id
        name
      }
      investmentGeographies {
        id
        name
      }
      investmentStages {
        id
        name
      }
      address {
        city
        country
        usState
      }
    }
    investorProfile {
      id
      checkSizeMinDollars
      checkSizeMaxDollars
      canLeadInvestments
      isVerifiedInvestor
    }
  }
}
    `;

/**
 * __useOnboardingProfileActivityQuery__
 *
 * To run a query within a React component, call `useOnboardingProfileActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingProfileActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingProfileActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingProfileActivityQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingProfileActivityQuery, OnboardingProfileActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingProfileActivityQuery, OnboardingProfileActivityQueryVariables>(OnboardingProfileActivityDocument, options);
      }
export function useOnboardingProfileActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingProfileActivityQuery, OnboardingProfileActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingProfileActivityQuery, OnboardingProfileActivityQueryVariables>(OnboardingProfileActivityDocument, options);
        }
export type OnboardingProfileActivityQueryHookResult = ReturnType<typeof useOnboardingProfileActivityQuery>;
export type OnboardingProfileActivityLazyQueryHookResult = ReturnType<typeof useOnboardingProfileActivityLazyQuery>;
export type OnboardingProfileActivityQueryResult = Apollo.QueryResult<OnboardingProfileActivityQuery, OnboardingProfileActivityQueryVariables>;
export const SaveOnboardingProfileDocument = gql`
    mutation SaveOnboardingProfile($companyProfile: SaveCompanyProfileInput!, $investorProfile: SaveInvestorProfileInput!, $isInvestor: Boolean!) {
  saveCompanyProfile(input: $companyProfile) {
    id
    name
    logo {
      id
      key
      fileName
    }
    websiteUrl
    phoneNumber
    description
    investmentAreas {
      id
    }
    investmentCategory {
      id
      name
    }
    investmentGeographies {
      id
      name
    }
    investmentStages {
      id
      name
    }
    address {
      city
      usState
      country
    }
  }
  saveInvestorProfile(input: $investorProfile) @include(if: $isInvestor) {
    id
    checkSizeMinDollars
    checkSizeMaxDollars
    canLeadInvestments
    isVerifiedInvestor
  }
}
    `;
export type SaveOnboardingProfileMutationFn = Apollo.MutationFunction<SaveOnboardingProfileMutation, SaveOnboardingProfileMutationVariables>;

/**
 * __useSaveOnboardingProfileMutation__
 *
 * To run a mutation, you first call `useSaveOnboardingProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOnboardingProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOnboardingProfileMutation, { data, loading, error }] = useSaveOnboardingProfileMutation({
 *   variables: {
 *      companyProfile: // value for 'companyProfile'
 *      investorProfile: // value for 'investorProfile'
 *      isInvestor: // value for 'isInvestor'
 *   },
 * });
 */
export function useSaveOnboardingProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveOnboardingProfileMutation, SaveOnboardingProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveOnboardingProfileMutation, SaveOnboardingProfileMutationVariables>(SaveOnboardingProfileDocument, options);
      }
export type SaveOnboardingProfileMutationHookResult = ReturnType<typeof useSaveOnboardingProfileMutation>;
export type SaveOnboardingProfileMutationResult = Apollo.MutationResult<SaveOnboardingProfileMutation>;
export type SaveOnboardingProfileMutationOptions = Apollo.BaseMutationOptions<SaveOnboardingProfileMutation, SaveOnboardingProfileMutationVariables>;
export const SaveUserTypeDocument = gql`
    mutation SaveUserType($siteUserId: ID!, $type: UserTypeName!) {
  saveSiteUser(input: {id: $siteUserId, type: $type}) {
    id
    type {
      id
      name
      displayName
    }
  }
}
    `;
export type SaveUserTypeMutationFn = Apollo.MutationFunction<SaveUserTypeMutation, SaveUserTypeMutationVariables>;

/**
 * __useSaveUserTypeMutation__
 *
 * To run a mutation, you first call `useSaveUserTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserTypeMutation, { data, loading, error }] = useSaveUserTypeMutation({
 *   variables: {
 *      siteUserId: // value for 'siteUserId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useSaveUserTypeMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserTypeMutation, SaveUserTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserTypeMutation, SaveUserTypeMutationVariables>(SaveUserTypeDocument, options);
      }
export type SaveUserTypeMutationHookResult = ReturnType<typeof useSaveUserTypeMutation>;
export type SaveUserTypeMutationResult = Apollo.MutationResult<SaveUserTypeMutation>;
export type SaveUserTypeMutationOptions = Apollo.BaseMutationOptions<SaveUserTypeMutation, SaveUserTypeMutationVariables>;
export const OnboardingUserTypeActivityDocument = gql`
    query OnboardingUserTypeActivity {
  allAccessEnabled
  loggedInUser {
    id
    type {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useOnboardingUserTypeActivityQuery__
 *
 * To run a query within a React component, call `useOnboardingUserTypeActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingUserTypeActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingUserTypeActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingUserTypeActivityQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingUserTypeActivityQuery, OnboardingUserTypeActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingUserTypeActivityQuery, OnboardingUserTypeActivityQueryVariables>(OnboardingUserTypeActivityDocument, options);
      }
export function useOnboardingUserTypeActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingUserTypeActivityQuery, OnboardingUserTypeActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingUserTypeActivityQuery, OnboardingUserTypeActivityQueryVariables>(OnboardingUserTypeActivityDocument, options);
        }
export type OnboardingUserTypeActivityQueryHookResult = ReturnType<typeof useOnboardingUserTypeActivityQuery>;
export type OnboardingUserTypeActivityLazyQueryHookResult = ReturnType<typeof useOnboardingUserTypeActivityLazyQuery>;
export type OnboardingUserTypeActivityQueryResult = Apollo.QueryResult<OnboardingUserTypeActivityQuery, OnboardingUserTypeActivityQueryVariables>;
export const RegisterSiteUserDocument = gql`
    mutation RegisterSiteUser($input: RegisterSiteUserInput!) {
  registerSiteUser(input: $input) {
    id
  }
}
    `;
export type RegisterSiteUserMutationFn = Apollo.MutationFunction<RegisterSiteUserMutation, RegisterSiteUserMutationVariables>;

/**
 * __useRegisterSiteUserMutation__
 *
 * To run a mutation, you first call `useRegisterSiteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterSiteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerSiteUserMutation, { data, loading, error }] = useRegisterSiteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterSiteUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterSiteUserMutation, RegisterSiteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterSiteUserMutation, RegisterSiteUserMutationVariables>(RegisterSiteUserDocument, options);
      }
export type RegisterSiteUserMutationHookResult = ReturnType<typeof useRegisterSiteUserMutation>;
export type RegisterSiteUserMutationResult = Apollo.MutationResult<RegisterSiteUserMutation>;
export type RegisterSiteUserMutationOptions = Apollo.BaseMutationOptions<RegisterSiteUserMutation, RegisterSiteUserMutationVariables>;
export const SignUpActivityDocument = gql`
    query SignUpActivity {
  loggedInUser {
    id
  }
}
    `;

/**
 * __useSignUpActivityQuery__
 *
 * To run a query within a React component, call `useSignUpActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignUpActivityQuery(baseOptions?: Apollo.QueryHookOptions<SignUpActivityQuery, SignUpActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignUpActivityQuery, SignUpActivityQueryVariables>(SignUpActivityDocument, options);
      }
export function useSignUpActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignUpActivityQuery, SignUpActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignUpActivityQuery, SignUpActivityQueryVariables>(SignUpActivityDocument, options);
        }
export type SignUpActivityQueryHookResult = ReturnType<typeof useSignUpActivityQuery>;
export type SignUpActivityLazyQueryHookResult = ReturnType<typeof useSignUpActivityLazyQuery>;
export type SignUpActivityQueryResult = Apollo.QueryResult<SignUpActivityQuery, SignUpActivityQueryVariables>;
export const SignUpActivity_SaveSiteUserDocument = gql`
    mutation SignUpActivity_SaveSiteUser($id: ID!, $firstName: String!, $lastName: String!) {
  saveSiteUser(input: {id: $id, firstName: $firstName, lastName: $lastName}) {
    id
    firstName
    lastName
  }
}
    `;
export type SignUpActivity_SaveSiteUserMutationFn = Apollo.MutationFunction<SignUpActivity_SaveSiteUserMutation, SignUpActivity_SaveSiteUserMutationVariables>;

/**
 * __useSignUpActivity_SaveSiteUserMutation__
 *
 * To run a mutation, you first call `useSignUpActivity_SaveSiteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpActivity_SaveSiteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpActivitySaveSiteUserMutation, { data, loading, error }] = useSignUpActivity_SaveSiteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useSignUpActivity_SaveSiteUserMutation(baseOptions?: Apollo.MutationHookOptions<SignUpActivity_SaveSiteUserMutation, SignUpActivity_SaveSiteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpActivity_SaveSiteUserMutation, SignUpActivity_SaveSiteUserMutationVariables>(SignUpActivity_SaveSiteUserDocument, options);
      }
export type SignUpActivity_SaveSiteUserMutationHookResult = ReturnType<typeof useSignUpActivity_SaveSiteUserMutation>;
export type SignUpActivity_SaveSiteUserMutationResult = Apollo.MutationResult<SignUpActivity_SaveSiteUserMutation>;
export type SignUpActivity_SaveSiteUserMutationOptions = Apollo.BaseMutationOptions<SignUpActivity_SaveSiteUserMutation, SignUpActivity_SaveSiteUserMutationVariables>;
export const VerifyEmailNotInUseDocument = gql`
    query VerifyEmailNotInUse($email: String!) {
  verifyEmailNotInUse(email: $email)
}
    `;

/**
 * __useVerifyEmailNotInUseQuery__
 *
 * To run a query within a React component, call `useVerifyEmailNotInUseQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailNotInUseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyEmailNotInUseQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useVerifyEmailNotInUseQuery(baseOptions: Apollo.QueryHookOptions<VerifyEmailNotInUseQuery, VerifyEmailNotInUseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifyEmailNotInUseQuery, VerifyEmailNotInUseQueryVariables>(VerifyEmailNotInUseDocument, options);
      }
export function useVerifyEmailNotInUseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyEmailNotInUseQuery, VerifyEmailNotInUseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifyEmailNotInUseQuery, VerifyEmailNotInUseQueryVariables>(VerifyEmailNotInUseDocument, options);
        }
export type VerifyEmailNotInUseQueryHookResult = ReturnType<typeof useVerifyEmailNotInUseQuery>;
export type VerifyEmailNotInUseLazyQueryHookResult = ReturnType<typeof useVerifyEmailNotInUseLazyQuery>;
export type VerifyEmailNotInUseQueryResult = Apollo.QueryResult<VerifyEmailNotInUseQuery, VerifyEmailNotInUseQueryVariables>;
export const AccessPassesTabPaneDocument = gql`
    query AccessPassesTabPane($paginationInput: PaginationInput) {
  accessPasses(options: {pagination: $paginationInput}) {
    pageInfo {
      nextPage
      pages
      previousPage
      totalRows
    }
    nodes {
      id
      email
      note
      startDate
      endDate
    }
  }
}
    `;

/**
 * __useAccessPassesTabPaneQuery__
 *
 * To run a query within a React component, call `useAccessPassesTabPaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessPassesTabPaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessPassesTabPaneQuery({
 *   variables: {
 *      paginationInput: // value for 'paginationInput'
 *   },
 * });
 */
export function useAccessPassesTabPaneQuery(baseOptions?: Apollo.QueryHookOptions<AccessPassesTabPaneQuery, AccessPassesTabPaneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessPassesTabPaneQuery, AccessPassesTabPaneQueryVariables>(AccessPassesTabPaneDocument, options);
      }
export function useAccessPassesTabPaneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessPassesTabPaneQuery, AccessPassesTabPaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessPassesTabPaneQuery, AccessPassesTabPaneQueryVariables>(AccessPassesTabPaneDocument, options);
        }
export type AccessPassesTabPaneQueryHookResult = ReturnType<typeof useAccessPassesTabPaneQuery>;
export type AccessPassesTabPaneLazyQueryHookResult = ReturnType<typeof useAccessPassesTabPaneLazyQuery>;
export type AccessPassesTabPaneQueryResult = Apollo.QueryResult<AccessPassesTabPaneQuery, AccessPassesTabPaneQueryVariables>;
export const AppSettingsTabPaneDocument = gql`
    query AppSettingsTabPane {
  allAccessEnabled
}
    `;

/**
 * __useAppSettingsTabPaneQuery__
 *
 * To run a query within a React component, call `useAppSettingsTabPaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppSettingsTabPaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppSettingsTabPaneQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppSettingsTabPaneQuery(baseOptions?: Apollo.QueryHookOptions<AppSettingsTabPaneQuery, AppSettingsTabPaneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppSettingsTabPaneQuery, AppSettingsTabPaneQueryVariables>(AppSettingsTabPaneDocument, options);
      }
export function useAppSettingsTabPaneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppSettingsTabPaneQuery, AppSettingsTabPaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppSettingsTabPaneQuery, AppSettingsTabPaneQueryVariables>(AppSettingsTabPaneDocument, options);
        }
export type AppSettingsTabPaneQueryHookResult = ReturnType<typeof useAppSettingsTabPaneQuery>;
export type AppSettingsTabPaneLazyQueryHookResult = ReturnType<typeof useAppSettingsTabPaneLazyQuery>;
export type AppSettingsTabPaneQueryResult = Apollo.QueryResult<AppSettingsTabPaneQuery, AppSettingsTabPaneQueryVariables>;
export const ToggleAllAccessDocument = gql`
    mutation ToggleAllAccess($enabled: Boolean!) {
  toggleAllAccess(enabled: $enabled)
}
    `;
export type ToggleAllAccessMutationFn = Apollo.MutationFunction<ToggleAllAccessMutation, ToggleAllAccessMutationVariables>;

/**
 * __useToggleAllAccessMutation__
 *
 * To run a mutation, you first call `useToggleAllAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAllAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAllAccessMutation, { data, loading, error }] = useToggleAllAccessMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useToggleAllAccessMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAllAccessMutation, ToggleAllAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleAllAccessMutation, ToggleAllAccessMutationVariables>(ToggleAllAccessDocument, options);
      }
export type ToggleAllAccessMutationHookResult = ReturnType<typeof useToggleAllAccessMutation>;
export type ToggleAllAccessMutationResult = Apollo.MutationResult<ToggleAllAccessMutation>;
export type ToggleAllAccessMutationOptions = Apollo.BaseMutationOptions<ToggleAllAccessMutation, ToggleAllAccessMutationVariables>;
export const DeleteInvestmentAreaDocument = gql`
    mutation DeleteInvestmentArea($id: ID!) {
  deleteInvestmentArea(id: $id)
}
    `;
export type DeleteInvestmentAreaMutationFn = Apollo.MutationFunction<DeleteInvestmentAreaMutation, DeleteInvestmentAreaMutationVariables>;

/**
 * __useDeleteInvestmentAreaMutation__
 *
 * To run a mutation, you first call `useDeleteInvestmentAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvestmentAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvestmentAreaMutation, { data, loading, error }] = useDeleteInvestmentAreaMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInvestmentAreaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvestmentAreaMutation, DeleteInvestmentAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvestmentAreaMutation, DeleteInvestmentAreaMutationVariables>(DeleteInvestmentAreaDocument, options);
      }
export type DeleteInvestmentAreaMutationHookResult = ReturnType<typeof useDeleteInvestmentAreaMutation>;
export type DeleteInvestmentAreaMutationResult = Apollo.MutationResult<DeleteInvestmentAreaMutation>;
export type DeleteInvestmentAreaMutationOptions = Apollo.BaseMutationOptions<DeleteInvestmentAreaMutation, DeleteInvestmentAreaMutationVariables>;
export const InvestmentAreasTabPaneDocument = gql`
    query InvestmentAreasTabPane {
  investmentAreas {
    id
    displayName
  }
}
    `;

/**
 * __useInvestmentAreasTabPaneQuery__
 *
 * To run a query within a React component, call `useInvestmentAreasTabPaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentAreasTabPaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentAreasTabPaneQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestmentAreasTabPaneQuery(baseOptions?: Apollo.QueryHookOptions<InvestmentAreasTabPaneQuery, InvestmentAreasTabPaneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestmentAreasTabPaneQuery, InvestmentAreasTabPaneQueryVariables>(InvestmentAreasTabPaneDocument, options);
      }
export function useInvestmentAreasTabPaneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestmentAreasTabPaneQuery, InvestmentAreasTabPaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestmentAreasTabPaneQuery, InvestmentAreasTabPaneQueryVariables>(InvestmentAreasTabPaneDocument, options);
        }
export type InvestmentAreasTabPaneQueryHookResult = ReturnType<typeof useInvestmentAreasTabPaneQuery>;
export type InvestmentAreasTabPaneLazyQueryHookResult = ReturnType<typeof useInvestmentAreasTabPaneLazyQuery>;
export type InvestmentAreasTabPaneQueryResult = Apollo.QueryResult<InvestmentAreasTabPaneQuery, InvestmentAreasTabPaneQueryVariables>;
export const DeleteUsersDocument = gql`
    mutation DeleteUsers($ids: [ID!]!) {
  deleteUsers(ids: $ids)
}
    `;
export type DeleteUsersMutationFn = Apollo.MutationFunction<DeleteUsersMutation, DeleteUsersMutationVariables>;

/**
 * __useDeleteUsersMutation__
 *
 * To run a mutation, you first call `useDeleteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUsersMutation, { data, loading, error }] = useDeleteUsersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteUsersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUsersMutation, DeleteUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUsersMutation, DeleteUsersMutationVariables>(DeleteUsersDocument, options);
      }
export type DeleteUsersMutationHookResult = ReturnType<typeof useDeleteUsersMutation>;
export type DeleteUsersMutationResult = Apollo.MutationResult<DeleteUsersMutation>;
export type DeleteUsersMutationOptions = Apollo.BaseMutationOptions<DeleteUsersMutation, DeleteUsersMutationVariables>;
export const InvestorsTabPaneDocument = gql`
    query InvestorsTabPane($paginationInput: PaginationInput!) {
  investmentCategories {
    id
    name
    displayName
  }
  users(paginationInput: $paginationInput, filterInput: {userType: investor}) {
    pageInfo {
      nextPage
      pages
      previousPage
      totalRows
    }
    nodes {
      id
      createdTimestamp
      isClaimed
      firstName
      lastName
      email
      companyProfile {
        id
        isVisible
        name
        phoneNumber
        investmentAreas {
          id
          displayName
        }
        investmentStages {
          id
          name
          displayName
        }
      }
      investorProfile {
        id
        isVerifiedInvestor
      }
    }
  }
}
    `;

/**
 * __useInvestorsTabPaneQuery__
 *
 * To run a query within a React component, call `useInvestorsTabPaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorsTabPaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorsTabPaneQuery({
 *   variables: {
 *      paginationInput: // value for 'paginationInput'
 *   },
 * });
 */
export function useInvestorsTabPaneQuery(baseOptions: Apollo.QueryHookOptions<InvestorsTabPaneQuery, InvestorsTabPaneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorsTabPaneQuery, InvestorsTabPaneQueryVariables>(InvestorsTabPaneDocument, options);
      }
export function useInvestorsTabPaneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestorsTabPaneQuery, InvestorsTabPaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorsTabPaneQuery, InvestorsTabPaneQueryVariables>(InvestorsTabPaneDocument, options);
        }
export type InvestorsTabPaneQueryHookResult = ReturnType<typeof useInvestorsTabPaneQuery>;
export type InvestorsTabPaneLazyQueryHookResult = ReturnType<typeof useInvestorsTabPaneLazyQuery>;
export type InvestorsTabPaneQueryResult = Apollo.QueryResult<InvestorsTabPaneQuery, InvestorsTabPaneQueryVariables>;
export const UpdateCompanyProfileVisibilityDocument = gql`
    mutation UpdateCompanyProfileVisibility($input: UpdateCompanyProfileVisibilityInput!) {
  updateCompanyProfileVisibility(input: $input) {
    id
    isVisible
  }
}
    `;
export type UpdateCompanyProfileVisibilityMutationFn = Apollo.MutationFunction<UpdateCompanyProfileVisibilityMutation, UpdateCompanyProfileVisibilityMutationVariables>;

/**
 * __useUpdateCompanyProfileVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyProfileVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyProfileVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyProfileVisibilityMutation, { data, loading, error }] = useUpdateCompanyProfileVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyProfileVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyProfileVisibilityMutation, UpdateCompanyProfileVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyProfileVisibilityMutation, UpdateCompanyProfileVisibilityMutationVariables>(UpdateCompanyProfileVisibilityDocument, options);
      }
export type UpdateCompanyProfileVisibilityMutationHookResult = ReturnType<typeof useUpdateCompanyProfileVisibilityMutation>;
export type UpdateCompanyProfileVisibilityMutationResult = Apollo.MutationResult<UpdateCompanyProfileVisibilityMutation>;
export type UpdateCompanyProfileVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyProfileVisibilityMutation, UpdateCompanyProfileVisibilityMutationVariables>;
export const VerifyInvestorDocument = gql`
    mutation VerifyInvestor($investorId: ID!) {
  saveInvestorProfile(input: {id: $investorId, isVerifiedInvestor: true}) {
    id
    isVerifiedInvestor
  }
}
    `;
export type VerifyInvestorMutationFn = Apollo.MutationFunction<VerifyInvestorMutation, VerifyInvestorMutationVariables>;

/**
 * __useVerifyInvestorMutation__
 *
 * To run a mutation, you first call `useVerifyInvestorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyInvestorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyInvestorMutation, { data, loading, error }] = useVerifyInvestorMutation({
 *   variables: {
 *      investorId: // value for 'investorId'
 *   },
 * });
 */
export function useVerifyInvestorMutation(baseOptions?: Apollo.MutationHookOptions<VerifyInvestorMutation, VerifyInvestorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyInvestorMutation, VerifyInvestorMutationVariables>(VerifyInvestorDocument, options);
      }
export type VerifyInvestorMutationHookResult = ReturnType<typeof useVerifyInvestorMutation>;
export type VerifyInvestorMutationResult = Apollo.MutationResult<VerifyInvestorMutation>;
export type VerifyInvestorMutationOptions = Apollo.BaseMutationOptions<VerifyInvestorMutation, VerifyInvestorMutationVariables>;
export const StartupsTabPaneDocument = gql`
    query StartupsTabPane($paginationInput: PaginationInput!) {
  users(
    paginationInput: $paginationInput
    filterInput: {userType: startupFounder}
  ) {
    pageInfo {
      nextPage
      pages
      previousPage
      totalRows
    }
    nodes {
      id
      createdTimestamp
      isClaimed
      firstName
      lastName
      email
      companyProfile {
        id
        name
        phoneNumber
        investmentAreas {
          id
          displayName
        }
        investmentStages {
          id
          name
          displayName
        }
      }
    }
  }
}
    `;

/**
 * __useStartupsTabPaneQuery__
 *
 * To run a query within a React component, call `useStartupsTabPaneQuery` and pass it any options that fit your needs.
 * When your component renders, `useStartupsTabPaneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStartupsTabPaneQuery({
 *   variables: {
 *      paginationInput: // value for 'paginationInput'
 *   },
 * });
 */
export function useStartupsTabPaneQuery(baseOptions: Apollo.QueryHookOptions<StartupsTabPaneQuery, StartupsTabPaneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StartupsTabPaneQuery, StartupsTabPaneQueryVariables>(StartupsTabPaneDocument, options);
      }
export function useStartupsTabPaneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StartupsTabPaneQuery, StartupsTabPaneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StartupsTabPaneQuery, StartupsTabPaneQueryVariables>(StartupsTabPaneDocument, options);
        }
export type StartupsTabPaneQueryHookResult = ReturnType<typeof useStartupsTabPaneQuery>;
export type StartupsTabPaneLazyQueryHookResult = ReturnType<typeof useStartupsTabPaneLazyQuery>;
export type StartupsTabPaneQueryResult = Apollo.QueryResult<StartupsTabPaneQuery, StartupsTabPaneQueryVariables>;
export const SaveAdminProfileDocument = gql`
    mutation SaveAdminProfile($input: SaveSiteUserInput!) {
  saveSiteUser(input: $input) {
    id
    firstName
    lastName
    email
  }
}
    `;
export type SaveAdminProfileMutationFn = Apollo.MutationFunction<SaveAdminProfileMutation, SaveAdminProfileMutationVariables>;

/**
 * __useSaveAdminProfileMutation__
 *
 * To run a mutation, you first call `useSaveAdminProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAdminProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAdminProfileMutation, { data, loading, error }] = useSaveAdminProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAdminProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveAdminProfileMutation, SaveAdminProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAdminProfileMutation, SaveAdminProfileMutationVariables>(SaveAdminProfileDocument, options);
      }
export type SaveAdminProfileMutationHookResult = ReturnType<typeof useSaveAdminProfileMutation>;
export type SaveAdminProfileMutationResult = Apollo.MutationResult<SaveAdminProfileMutation>;
export type SaveAdminProfileMutationOptions = Apollo.BaseMutationOptions<SaveAdminProfileMutation, SaveAdminProfileMutationVariables>;
export const SuperAdminUserProfileActivityDocument = gql`
    query SuperAdminUserProfileActivity {
  loggedInUser {
    id
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useSuperAdminUserProfileActivityQuery__
 *
 * To run a query within a React component, call `useSuperAdminUserProfileActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperAdminUserProfileActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperAdminUserProfileActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperAdminUserProfileActivityQuery(baseOptions?: Apollo.QueryHookOptions<SuperAdminUserProfileActivityQuery, SuperAdminUserProfileActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuperAdminUserProfileActivityQuery, SuperAdminUserProfileActivityQueryVariables>(SuperAdminUserProfileActivityDocument, options);
      }
export function useSuperAdminUserProfileActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuperAdminUserProfileActivityQuery, SuperAdminUserProfileActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuperAdminUserProfileActivityQuery, SuperAdminUserProfileActivityQueryVariables>(SuperAdminUserProfileActivityDocument, options);
        }
export type SuperAdminUserProfileActivityQueryHookResult = ReturnType<typeof useSuperAdminUserProfileActivityQuery>;
export type SuperAdminUserProfileActivityLazyQueryHookResult = ReturnType<typeof useSuperAdminUserProfileActivityLazyQuery>;
export type SuperAdminUserProfileActivityQueryResult = Apollo.QueryResult<SuperAdminUserProfileActivityQuery, SuperAdminUserProfileActivityQueryVariables>;
export const AllAccessWallDocument = gql`
    query AllAccessWall {
  allAccessEnabled
}
    `;

/**
 * __useAllAccessWallQuery__
 *
 * To run a query within a React component, call `useAllAccessWallQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAccessWallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAccessWallQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAccessWallQuery(baseOptions?: Apollo.QueryHookOptions<AllAccessWallQuery, AllAccessWallQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAccessWallQuery, AllAccessWallQueryVariables>(AllAccessWallDocument, options);
      }
export function useAllAccessWallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAccessWallQuery, AllAccessWallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAccessWallQuery, AllAccessWallQueryVariables>(AllAccessWallDocument, options);
        }
export type AllAccessWallQueryHookResult = ReturnType<typeof useAllAccessWallQuery>;
export type AllAccessWallLazyQueryHookResult = ReturnType<typeof useAllAccessWallLazyQuery>;
export type AllAccessWallQueryResult = Apollo.QueryResult<AllAccessWallQuery, AllAccessWallQueryVariables>;
export const CancelSubscriptionDocument = gql`
    mutation CancelSubscription {
  cancelSubscription {
    id
    subscriptionInfo {
      id
      status
      willCancelAtPeriodEnd
      currentPeriodEnd
    }
  }
}
    `;
export type CancelSubscriptionMutationFn = Apollo.MutationFunction<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;

/**
 * __useCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionMutation, { data, loading, error }] = useCancelSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>(CancelSubscriptionDocument, options);
      }
export type CancelSubscriptionMutationHookResult = ReturnType<typeof useCancelSubscriptionMutation>;
export type CancelSubscriptionMutationResult = Apollo.MutationResult<CancelSubscriptionMutation>;
export type CancelSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionMutation, CancelSubscriptionMutationVariables>;
export const CancelSubscriptionModalDocument = gql`
    query CancelSubscriptionModal {
  loggedInUser {
    id
    subscriptionInfo {
      id
      status
      willCancelAtPeriodEnd
      currentPeriodEnd
    }
  }
}
    `;

/**
 * __useCancelSubscriptionModalQuery__
 *
 * To run a query within a React component, call `useCancelSubscriptionModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancelSubscriptionModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useCancelSubscriptionModalQuery(baseOptions?: Apollo.QueryHookOptions<CancelSubscriptionModalQuery, CancelSubscriptionModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancelSubscriptionModalQuery, CancelSubscriptionModalQueryVariables>(CancelSubscriptionModalDocument, options);
      }
export function useCancelSubscriptionModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancelSubscriptionModalQuery, CancelSubscriptionModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancelSubscriptionModalQuery, CancelSubscriptionModalQueryVariables>(CancelSubscriptionModalDocument, options);
        }
export type CancelSubscriptionModalQueryHookResult = ReturnType<typeof useCancelSubscriptionModalQuery>;
export type CancelSubscriptionModalLazyQueryHookResult = ReturnType<typeof useCancelSubscriptionModalLazyQuery>;
export type CancelSubscriptionModalQueryResult = Apollo.QueryResult<CancelSubscriptionModalQuery, CancelSubscriptionModalQueryVariables>;
export const DeleteLoggedInUserDocument = gql`
    mutation DeleteLoggedInUser {
  deleteLoggedInUser
}
    `;
export type DeleteLoggedInUserMutationFn = Apollo.MutationFunction<DeleteLoggedInUserMutation, DeleteLoggedInUserMutationVariables>;

/**
 * __useDeleteLoggedInUserMutation__
 *
 * To run a mutation, you first call `useDeleteLoggedInUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLoggedInUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLoggedInUserMutation, { data, loading, error }] = useDeleteLoggedInUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteLoggedInUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLoggedInUserMutation, DeleteLoggedInUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLoggedInUserMutation, DeleteLoggedInUserMutationVariables>(DeleteLoggedInUserDocument, options);
      }
export type DeleteLoggedInUserMutationHookResult = ReturnType<typeof useDeleteLoggedInUserMutation>;
export type DeleteLoggedInUserMutationResult = Apollo.MutationResult<DeleteLoggedInUserMutation>;
export type DeleteLoggedInUserMutationOptions = Apollo.BaseMutationOptions<DeleteLoggedInUserMutation, DeleteLoggedInUserMutationVariables>;
export const DownloadsRemainingDocument = gql`
    query DownloadsRemaining {
  allAccessEnabled
  loggedInUser {
    id
    downloadsAllowed
    downloadUsageForCycle
    subscriptionInfo {
      status
    }
  }
}
    `;

/**
 * __useDownloadsRemainingQuery__
 *
 * To run a query within a React component, call `useDownloadsRemainingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadsRemainingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadsRemainingQuery({
 *   variables: {
 *   },
 * });
 */
export function useDownloadsRemainingQuery(baseOptions?: Apollo.QueryHookOptions<DownloadsRemainingQuery, DownloadsRemainingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadsRemainingQuery, DownloadsRemainingQueryVariables>(DownloadsRemainingDocument, options);
      }
export function useDownloadsRemainingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadsRemainingQuery, DownloadsRemainingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadsRemainingQuery, DownloadsRemainingQueryVariables>(DownloadsRemainingDocument, options);
        }
export type DownloadsRemainingQueryHookResult = ReturnType<typeof useDownloadsRemainingQuery>;
export type DownloadsRemainingLazyQueryHookResult = ReturnType<typeof useDownloadsRemainingLazyQuery>;
export type DownloadsRemainingQueryResult = Apollo.QueryResult<DownloadsRemainingQuery, DownloadsRemainingQueryVariables>;
export const FavoriteInvestorDocument = gql`
    mutation FavoriteInvestor($input: FavoriteInvestorInput!) {
  favoriteInvestor(input: $input)
}
    `;
export type FavoriteInvestorMutationFn = Apollo.MutationFunction<FavoriteInvestorMutation, FavoriteInvestorMutationVariables>;

/**
 * __useFavoriteInvestorMutation__
 *
 * To run a mutation, you first call `useFavoriteInvestorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFavoriteInvestorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [favoriteInvestorMutation, { data, loading, error }] = useFavoriteInvestorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFavoriteInvestorMutation(baseOptions?: Apollo.MutationHookOptions<FavoriteInvestorMutation, FavoriteInvestorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FavoriteInvestorMutation, FavoriteInvestorMutationVariables>(FavoriteInvestorDocument, options);
      }
export type FavoriteInvestorMutationHookResult = ReturnType<typeof useFavoriteInvestorMutation>;
export type FavoriteInvestorMutationResult = Apollo.MutationResult<FavoriteInvestorMutation>;
export type FavoriteInvestorMutationOptions = Apollo.BaseMutationOptions<FavoriteInvestorMutation, FavoriteInvestorMutationVariables>;
export const UserAccountButtonDocument = gql`
    query UserAccountButton {
  loggedInUser {
    id
    isSuperAdmin
    firstName
    lastName
  }
}
    `;

/**
 * __useUserAccountButtonQuery__
 *
 * To run a query within a React component, call `useUserAccountButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAccountButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAccountButtonQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserAccountButtonQuery(baseOptions?: Apollo.QueryHookOptions<UserAccountButtonQuery, UserAccountButtonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAccountButtonQuery, UserAccountButtonQueryVariables>(UserAccountButtonDocument, options);
      }
export function useUserAccountButtonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAccountButtonQuery, UserAccountButtonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAccountButtonQuery, UserAccountButtonQueryVariables>(UserAccountButtonDocument, options);
        }
export type UserAccountButtonQueryHookResult = ReturnType<typeof useUserAccountButtonQuery>;
export type UserAccountButtonLazyQueryHookResult = ReturnType<typeof useUserAccountButtonLazyQuery>;
export type UserAccountButtonQueryResult = Apollo.QueryResult<UserAccountButtonQuery, UserAccountButtonQueryVariables>;
export const BeginSubscriptionDocument = gql`
    query BeginSubscription {
  loggedInUser {
    id
    subscriptionInfo {
      status
      currentPeriodEnd
    }
  }
}
    `;

/**
 * __useBeginSubscriptionQuery__
 *
 * To run a query within a React component, call `useBeginSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeginSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeginSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useBeginSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<BeginSubscriptionQuery, BeginSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeginSubscriptionQuery, BeginSubscriptionQueryVariables>(BeginSubscriptionDocument, options);
      }
export function useBeginSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeginSubscriptionQuery, BeginSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeginSubscriptionQuery, BeginSubscriptionQueryVariables>(BeginSubscriptionDocument, options);
        }
export type BeginSubscriptionQueryHookResult = ReturnType<typeof useBeginSubscriptionQuery>;
export type BeginSubscriptionLazyQueryHookResult = ReturnType<typeof useBeginSubscriptionLazyQuery>;
export type BeginSubscriptionQueryResult = Apollo.QueryResult<BeginSubscriptionQuery, BeginSubscriptionQueryVariables>;
export const EndTrialEarlyDocument = gql`
    mutation EndTrialEarly {
  endTrialEarly
}
    `;
export type EndTrialEarlyMutationFn = Apollo.MutationFunction<EndTrialEarlyMutation, EndTrialEarlyMutationVariables>;

/**
 * __useEndTrialEarlyMutation__
 *
 * To run a mutation, you first call `useEndTrialEarlyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndTrialEarlyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endTrialEarlyMutation, { data, loading, error }] = useEndTrialEarlyMutation({
 *   variables: {
 *   },
 * });
 */
export function useEndTrialEarlyMutation(baseOptions?: Apollo.MutationHookOptions<EndTrialEarlyMutation, EndTrialEarlyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndTrialEarlyMutation, EndTrialEarlyMutationVariables>(EndTrialEarlyDocument, options);
      }
export type EndTrialEarlyMutationHookResult = ReturnType<typeof useEndTrialEarlyMutation>;
export type EndTrialEarlyMutationResult = Apollo.MutationResult<EndTrialEarlyMutation>;
export type EndTrialEarlyMutationOptions = Apollo.BaseMutationOptions<EndTrialEarlyMutation, EndTrialEarlyMutationVariables>;
export const LegalDocumentsDocument = gql`
    query LegalDocuments($extension: [String!]) {
  legalDocuments(extension: $extension) {
    id
    title
    extension
    file {
      id
      key
      fileName
    }
  }
}
    `;

/**
 * __useLegalDocumentsQuery__
 *
 * To run a query within a React component, call `useLegalDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalDocumentsQuery({
 *   variables: {
 *      extension: // value for 'extension'
 *   },
 * });
 */
export function useLegalDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<LegalDocumentsQuery, LegalDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalDocumentsQuery, LegalDocumentsQueryVariables>(LegalDocumentsDocument, options);
      }
export function useLegalDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalDocumentsQuery, LegalDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalDocumentsQuery, LegalDocumentsQueryVariables>(LegalDocumentsDocument, options);
        }
export type LegalDocumentsQueryHookResult = ReturnType<typeof useLegalDocumentsQuery>;
export type LegalDocumentsLazyQueryHookResult = ReturnType<typeof useLegalDocumentsLazyQuery>;
export type LegalDocumentsQueryResult = Apollo.QueryResult<LegalDocumentsQuery, LegalDocumentsQueryVariables>;
export const AuthWrapperDocument = gql`
    query AuthWrapper {
  allAccessEnabled
  loggedInUser {
    id
    isSuperAdmin
    subscriptionStatus
    type {
      id
      name
      displayName
    }
    companyProfile {
      id
    }
    activeAccessPass {
      id
      startDate
      endDate
    }
  }
}
    `;

/**
 * __useAuthWrapperQuery__
 *
 * To run a query within a React component, call `useAuthWrapperQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthWrapperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthWrapperQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthWrapperQuery(baseOptions?: Apollo.QueryHookOptions<AuthWrapperQuery, AuthWrapperQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthWrapperQuery, AuthWrapperQueryVariables>(AuthWrapperDocument, options);
      }
export function useAuthWrapperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthWrapperQuery, AuthWrapperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthWrapperQuery, AuthWrapperQueryVariables>(AuthWrapperDocument, options);
        }
export type AuthWrapperQueryHookResult = ReturnType<typeof useAuthWrapperQuery>;
export type AuthWrapperLazyQueryHookResult = ReturnType<typeof useAuthWrapperLazyQuery>;
export type AuthWrapperQueryResult = Apollo.QueryResult<AuthWrapperQuery, AuthWrapperQueryVariables>;
export const BaseOnboardingTemplateDocument = gql`
    query BaseOnboardingTemplate {
  allAccessEnabled
}
    `;

/**
 * __useBaseOnboardingTemplateQuery__
 *
 * To run a query within a React component, call `useBaseOnboardingTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBaseOnboardingTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBaseOnboardingTemplateQuery({
 *   variables: {
 *   },
 * });
 */
export function useBaseOnboardingTemplateQuery(baseOptions?: Apollo.QueryHookOptions<BaseOnboardingTemplateQuery, BaseOnboardingTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BaseOnboardingTemplateQuery, BaseOnboardingTemplateQueryVariables>(BaseOnboardingTemplateDocument, options);
      }
export function useBaseOnboardingTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BaseOnboardingTemplateQuery, BaseOnboardingTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BaseOnboardingTemplateQuery, BaseOnboardingTemplateQueryVariables>(BaseOnboardingTemplateDocument, options);
        }
export type BaseOnboardingTemplateQueryHookResult = ReturnType<typeof useBaseOnboardingTemplateQuery>;
export type BaseOnboardingTemplateLazyQueryHookResult = ReturnType<typeof useBaseOnboardingTemplateLazyQuery>;
export type BaseOnboardingTemplateQueryResult = Apollo.QueryResult<BaseOnboardingTemplateQuery, BaseOnboardingTemplateQueryVariables>;
export const AllEnumsDocument = gql`
    query AllEnums {
  investmentCategories {
    id
    name
    displayName
  }
  investmentGeographies {
    id
    name
    displayName
    parentName
    ranking
  }
  investmentStages {
    id
    name
    displayName
  }
  investmentAreas {
    id
    displayName
  }
  usStates {
    id
    displayName
  }
  fundingStages {
    id
    name
    displayName
  }
}
    `;

/**
 * __useAllEnumsQuery__
 *
 * To run a query within a React component, call `useAllEnumsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEnumsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEnumsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllEnumsQuery(baseOptions?: Apollo.QueryHookOptions<AllEnumsQuery, AllEnumsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllEnumsQuery, AllEnumsQueryVariables>(AllEnumsDocument, options);
      }
export function useAllEnumsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllEnumsQuery, AllEnumsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllEnumsQuery, AllEnumsQueryVariables>(AllEnumsDocument, options);
        }
export type AllEnumsQueryHookResult = ReturnType<typeof useAllEnumsQuery>;
export type AllEnumsLazyQueryHookResult = ReturnType<typeof useAllEnumsLazyQuery>;
export type AllEnumsQueryResult = Apollo.QueryResult<AllEnumsQuery, AllEnumsQueryVariables>;
export const FundingStageSelectFieldDocument = gql`
    query FundingStageSelectField {
  fundingStages {
    id
    name
    displayName
  }
}
    `;

/**
 * __useFundingStageSelectFieldQuery__
 *
 * To run a query within a React component, call `useFundingStageSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundingStageSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundingStageSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundingStageSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<FundingStageSelectFieldQuery, FundingStageSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundingStageSelectFieldQuery, FundingStageSelectFieldQueryVariables>(FundingStageSelectFieldDocument, options);
      }
export function useFundingStageSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundingStageSelectFieldQuery, FundingStageSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundingStageSelectFieldQuery, FundingStageSelectFieldQueryVariables>(FundingStageSelectFieldDocument, options);
        }
export type FundingStageSelectFieldQueryHookResult = ReturnType<typeof useFundingStageSelectFieldQuery>;
export type FundingStageSelectFieldLazyQueryHookResult = ReturnType<typeof useFundingStageSelectFieldLazyQuery>;
export type FundingStageSelectFieldQueryResult = Apollo.QueryResult<FundingStageSelectFieldQuery, FundingStageSelectFieldQueryVariables>;
export const InvestmentAreaSelectFieldDocument = gql`
    query InvestmentAreaSelectField {
  investmentAreas {
    id
    displayName
  }
}
    `;

/**
 * __useInvestmentAreaSelectFieldQuery__
 *
 * To run a query within a React component, call `useInvestmentAreaSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentAreaSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentAreaSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestmentAreaSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<InvestmentAreaSelectFieldQuery, InvestmentAreaSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestmentAreaSelectFieldQuery, InvestmentAreaSelectFieldQueryVariables>(InvestmentAreaSelectFieldDocument, options);
      }
export function useInvestmentAreaSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestmentAreaSelectFieldQuery, InvestmentAreaSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestmentAreaSelectFieldQuery, InvestmentAreaSelectFieldQueryVariables>(InvestmentAreaSelectFieldDocument, options);
        }
export type InvestmentAreaSelectFieldQueryHookResult = ReturnType<typeof useInvestmentAreaSelectFieldQuery>;
export type InvestmentAreaSelectFieldLazyQueryHookResult = ReturnType<typeof useInvestmentAreaSelectFieldLazyQuery>;
export type InvestmentAreaSelectFieldQueryResult = Apollo.QueryResult<InvestmentAreaSelectFieldQuery, InvestmentAreaSelectFieldQueryVariables>;
export const InvestmentCategorySelectFieldDocument = gql`
    query InvestmentCategorySelectField {
  investmentCategories {
    id
    name
    displayName
  }
}
    `;

/**
 * __useInvestmentCategorySelectFieldQuery__
 *
 * To run a query within a React component, call `useInvestmentCategorySelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentCategorySelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentCategorySelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestmentCategorySelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<InvestmentCategorySelectFieldQuery, InvestmentCategorySelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestmentCategorySelectFieldQuery, InvestmentCategorySelectFieldQueryVariables>(InvestmentCategorySelectFieldDocument, options);
      }
export function useInvestmentCategorySelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestmentCategorySelectFieldQuery, InvestmentCategorySelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestmentCategorySelectFieldQuery, InvestmentCategorySelectFieldQueryVariables>(InvestmentCategorySelectFieldDocument, options);
        }
export type InvestmentCategorySelectFieldQueryHookResult = ReturnType<typeof useInvestmentCategorySelectFieldQuery>;
export type InvestmentCategorySelectFieldLazyQueryHookResult = ReturnType<typeof useInvestmentCategorySelectFieldLazyQuery>;
export type InvestmentCategorySelectFieldQueryResult = Apollo.QueryResult<InvestmentCategorySelectFieldQuery, InvestmentCategorySelectFieldQueryVariables>;
export const InvestmentGeographySelectFieldDocument = gql`
    query InvestmentGeographySelectField {
  investmentGeographies {
    id
    name
    displayName
    parentName
    ranking
  }
}
    `;

/**
 * __useInvestmentGeographySelectFieldQuery__
 *
 * To run a query within a React component, call `useInvestmentGeographySelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentGeographySelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentGeographySelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestmentGeographySelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<InvestmentGeographySelectFieldQuery, InvestmentGeographySelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestmentGeographySelectFieldQuery, InvestmentGeographySelectFieldQueryVariables>(InvestmentGeographySelectFieldDocument, options);
      }
export function useInvestmentGeographySelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestmentGeographySelectFieldQuery, InvestmentGeographySelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestmentGeographySelectFieldQuery, InvestmentGeographySelectFieldQueryVariables>(InvestmentGeographySelectFieldDocument, options);
        }
export type InvestmentGeographySelectFieldQueryHookResult = ReturnType<typeof useInvestmentGeographySelectFieldQuery>;
export type InvestmentGeographySelectFieldLazyQueryHookResult = ReturnType<typeof useInvestmentGeographySelectFieldLazyQuery>;
export type InvestmentGeographySelectFieldQueryResult = Apollo.QueryResult<InvestmentGeographySelectFieldQuery, InvestmentGeographySelectFieldQueryVariables>;
export const InvestmentStageSelectFieldDocument = gql`
    query InvestmentStageSelectField {
  investmentStages {
    id
    name
    displayName
  }
}
    `;

/**
 * __useInvestmentStageSelectFieldQuery__
 *
 * To run a query within a React component, call `useInvestmentStageSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentStageSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentStageSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useInvestmentStageSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<InvestmentStageSelectFieldQuery, InvestmentStageSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestmentStageSelectFieldQuery, InvestmentStageSelectFieldQueryVariables>(InvestmentStageSelectFieldDocument, options);
      }
export function useInvestmentStageSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvestmentStageSelectFieldQuery, InvestmentStageSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestmentStageSelectFieldQuery, InvestmentStageSelectFieldQueryVariables>(InvestmentStageSelectFieldDocument, options);
        }
export type InvestmentStageSelectFieldQueryHookResult = ReturnType<typeof useInvestmentStageSelectFieldQuery>;
export type InvestmentStageSelectFieldLazyQueryHookResult = ReturnType<typeof useInvestmentStageSelectFieldLazyQuery>;
export type InvestmentStageSelectFieldQueryResult = Apollo.QueryResult<InvestmentStageSelectFieldQuery, InvestmentStageSelectFieldQueryVariables>;
export const UsStateSelectFieldDocument = gql`
    query USStateSelectField {
  usStates {
    id
    displayName
  }
}
    `;

/**
 * __useUsStateSelectFieldQuery__
 *
 * To run a query within a React component, call `useUsStateSelectFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsStateSelectFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsStateSelectFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useUsStateSelectFieldQuery(baseOptions?: Apollo.QueryHookOptions<UsStateSelectFieldQuery, UsStateSelectFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsStateSelectFieldQuery, UsStateSelectFieldQueryVariables>(UsStateSelectFieldDocument, options);
      }
export function useUsStateSelectFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsStateSelectFieldQuery, UsStateSelectFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsStateSelectFieldQuery, UsStateSelectFieldQueryVariables>(UsStateSelectFieldDocument, options);
        }
export type UsStateSelectFieldQueryHookResult = ReturnType<typeof useUsStateSelectFieldQuery>;
export type UsStateSelectFieldLazyQueryHookResult = ReturnType<typeof useUsStateSelectFieldLazyQuery>;
export type UsStateSelectFieldQueryResult = Apollo.QueryResult<UsStateSelectFieldQuery, UsStateSelectFieldQueryVariables>;
export const InviteSuperAdminDocument = gql`
    mutation InviteSuperAdmin($input: InviteSuperAdminInput!) {
  inviteSuperAdmin(input: $input) {
    id
    firstName
    lastName
    isSuperAdmin
  }
}
    `;
export type InviteSuperAdminMutationFn = Apollo.MutationFunction<InviteSuperAdminMutation, InviteSuperAdminMutationVariables>;

/**
 * __useInviteSuperAdminMutation__
 *
 * To run a mutation, you first call `useInviteSuperAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteSuperAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteSuperAdminMutation, { data, loading, error }] = useInviteSuperAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteSuperAdminMutation(baseOptions?: Apollo.MutationHookOptions<InviteSuperAdminMutation, InviteSuperAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteSuperAdminMutation, InviteSuperAdminMutationVariables>(InviteSuperAdminDocument, options);
      }
export type InviteSuperAdminMutationHookResult = ReturnType<typeof useInviteSuperAdminMutation>;
export type InviteSuperAdminMutationResult = Apollo.MutationResult<InviteSuperAdminMutation>;
export type InviteSuperAdminMutationOptions = Apollo.BaseMutationOptions<InviteSuperAdminMutation, InviteSuperAdminMutationVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($input: CreateAccountInput!) {
  createAccount(input: $input) {
    id
    email
    isClaimed
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const EditAccessPassModalDocument = gql`
    query EditAccessPassModal($accessPassId: ID!) {
  accessPass(id: $accessPassId) {
    id
    email
    note
    startDate
    endDate
  }
}
    `;

/**
 * __useEditAccessPassModalQuery__
 *
 * To run a query within a React component, call `useEditAccessPassModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditAccessPassModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditAccessPassModalQuery({
 *   variables: {
 *      accessPassId: // value for 'accessPassId'
 *   },
 * });
 */
export function useEditAccessPassModalQuery(baseOptions: Apollo.QueryHookOptions<EditAccessPassModalQuery, EditAccessPassModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditAccessPassModalQuery, EditAccessPassModalQueryVariables>(EditAccessPassModalDocument, options);
      }
export function useEditAccessPassModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditAccessPassModalQuery, EditAccessPassModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditAccessPassModalQuery, EditAccessPassModalQueryVariables>(EditAccessPassModalDocument, options);
        }
export type EditAccessPassModalQueryHookResult = ReturnType<typeof useEditAccessPassModalQuery>;
export type EditAccessPassModalLazyQueryHookResult = ReturnType<typeof useEditAccessPassModalLazyQuery>;
export type EditAccessPassModalQueryResult = Apollo.QueryResult<EditAccessPassModalQuery, EditAccessPassModalQueryVariables>;
export const SaveAccessPassDocument = gql`
    mutation SaveAccessPass($input: SaveAccessPassInput!) {
  saveAccessPass(input: $input) {
    id
    email
    note
    startDate
    endDate
  }
}
    `;
export type SaveAccessPassMutationFn = Apollo.MutationFunction<SaveAccessPassMutation, SaveAccessPassMutationVariables>;

/**
 * __useSaveAccessPassMutation__
 *
 * To run a mutation, you first call `useSaveAccessPassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAccessPassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAccessPassMutation, { data, loading, error }] = useSaveAccessPassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAccessPassMutation(baseOptions?: Apollo.MutationHookOptions<SaveAccessPassMutation, SaveAccessPassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAccessPassMutation, SaveAccessPassMutationVariables>(SaveAccessPassDocument, options);
      }
export type SaveAccessPassMutationHookResult = ReturnType<typeof useSaveAccessPassMutation>;
export type SaveAccessPassMutationResult = Apollo.MutationResult<SaveAccessPassMutation>;
export type SaveAccessPassMutationOptions = Apollo.BaseMutationOptions<SaveAccessPassMutation, SaveAccessPassMutationVariables>;
export const OverrideActorStageDisplayNameDocument = gql`
    mutation OverrideActorStageDisplayName($input: OverrideActorStageDisplayNameInput!) {
  overrideActorStageDisplayName(input: $input) {
    id
    name
    displayName
    overrideDisplayName
  }
}
    `;
export type OverrideActorStageDisplayNameMutationFn = Apollo.MutationFunction<OverrideActorStageDisplayNameMutation, OverrideActorStageDisplayNameMutationVariables>;

/**
 * __useOverrideActorStageDisplayNameMutation__
 *
 * To run a mutation, you first call `useOverrideActorStageDisplayNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideActorStageDisplayNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideActorStageDisplayNameMutation, { data, loading, error }] = useOverrideActorStageDisplayNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOverrideActorStageDisplayNameMutation(baseOptions?: Apollo.MutationHookOptions<OverrideActorStageDisplayNameMutation, OverrideActorStageDisplayNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideActorStageDisplayNameMutation, OverrideActorStageDisplayNameMutationVariables>(OverrideActorStageDisplayNameDocument, options);
      }
export type OverrideActorStageDisplayNameMutationHookResult = ReturnType<typeof useOverrideActorStageDisplayNameMutation>;
export type OverrideActorStageDisplayNameMutationResult = Apollo.MutationResult<OverrideActorStageDisplayNameMutation>;
export type OverrideActorStageDisplayNameMutationOptions = Apollo.BaseMutationOptions<OverrideActorStageDisplayNameMutation, OverrideActorStageDisplayNameMutationVariables>;
export const EditInvestmentAreaModalDocument = gql`
    query EditInvestmentAreaModal($investmentAreaId: ID!) {
  investmentArea(id: $investmentAreaId) {
    id
    displayName
  }
}
    `;

/**
 * __useEditInvestmentAreaModalQuery__
 *
 * To run a query within a React component, call `useEditInvestmentAreaModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditInvestmentAreaModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditInvestmentAreaModalQuery({
 *   variables: {
 *      investmentAreaId: // value for 'investmentAreaId'
 *   },
 * });
 */
export function useEditInvestmentAreaModalQuery(baseOptions: Apollo.QueryHookOptions<EditInvestmentAreaModalQuery, EditInvestmentAreaModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditInvestmentAreaModalQuery, EditInvestmentAreaModalQueryVariables>(EditInvestmentAreaModalDocument, options);
      }
export function useEditInvestmentAreaModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditInvestmentAreaModalQuery, EditInvestmentAreaModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditInvestmentAreaModalQuery, EditInvestmentAreaModalQueryVariables>(EditInvestmentAreaModalDocument, options);
        }
export type EditInvestmentAreaModalQueryHookResult = ReturnType<typeof useEditInvestmentAreaModalQuery>;
export type EditInvestmentAreaModalLazyQueryHookResult = ReturnType<typeof useEditInvestmentAreaModalLazyQuery>;
export type EditInvestmentAreaModalQueryResult = Apollo.QueryResult<EditInvestmentAreaModalQuery, EditInvestmentAreaModalQueryVariables>;
export const SaveInvestmentAreaDocument = gql`
    mutation SaveInvestmentArea($input: SaveInvestmentAreaInput!) {
  saveInvestmentArea(input: $input) {
    id
    displayName
  }
}
    `;
export type SaveInvestmentAreaMutationFn = Apollo.MutationFunction<SaveInvestmentAreaMutation, SaveInvestmentAreaMutationVariables>;

/**
 * __useSaveInvestmentAreaMutation__
 *
 * To run a mutation, you first call `useSaveInvestmentAreaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveInvestmentAreaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveInvestmentAreaMutation, { data, loading, error }] = useSaveInvestmentAreaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveInvestmentAreaMutation(baseOptions?: Apollo.MutationHookOptions<SaveInvestmentAreaMutation, SaveInvestmentAreaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveInvestmentAreaMutation, SaveInvestmentAreaMutationVariables>(SaveInvestmentAreaDocument, options);
      }
export type SaveInvestmentAreaMutationHookResult = ReturnType<typeof useSaveInvestmentAreaMutation>;
export type SaveInvestmentAreaMutationResult = Apollo.MutationResult<SaveInvestmentAreaMutation>;
export type SaveInvestmentAreaMutationOptions = Apollo.BaseMutationOptions<SaveInvestmentAreaMutation, SaveInvestmentAreaMutationVariables>;
export const EditInvestorCardModalDocument = gql`
    query EditInvestorCardModal($investorCardId: ID!) {
  investorCard(id: $investorCardId) {
    id
    displayName
    potentialInvestmentAmountDollars
    investorProfile {
      id
    }
  }
}
    `;

/**
 * __useEditInvestorCardModalQuery__
 *
 * To run a query within a React component, call `useEditInvestorCardModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditInvestorCardModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditInvestorCardModalQuery({
 *   variables: {
 *      investorCardId: // value for 'investorCardId'
 *   },
 * });
 */
export function useEditInvestorCardModalQuery(baseOptions: Apollo.QueryHookOptions<EditInvestorCardModalQuery, EditInvestorCardModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditInvestorCardModalQuery, EditInvestorCardModalQueryVariables>(EditInvestorCardModalDocument, options);
      }
export function useEditInvestorCardModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditInvestorCardModalQuery, EditInvestorCardModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditInvestorCardModalQuery, EditInvestorCardModalQueryVariables>(EditInvestorCardModalDocument, options);
        }
export type EditInvestorCardModalQueryHookResult = ReturnType<typeof useEditInvestorCardModalQuery>;
export type EditInvestorCardModalLazyQueryHookResult = ReturnType<typeof useEditInvestorCardModalLazyQuery>;
export type EditInvestorCardModalQueryResult = Apollo.QueryResult<EditInvestorCardModalQuery, EditInvestorCardModalQueryVariables>;
export const SaveUserProfileDocument = gql`
    mutation SaveUserProfile($userInput: SaveSiteUserInput!, $companyProfileInput: SaveCompanyProfileInput!, $investorProfile: SaveInvestorProfileInput!, $isInvestor: Boolean!) {
  saveSiteUser(input: $userInput) {
    id
    firstName
    lastName
    email
  }
  saveCompanyProfile(input: $companyProfileInput) {
    id
    name
    websiteUrl
    description
    phoneNumber
    investmentAreas {
      id
      displayName
    }
    investmentCategory {
      id
      name
      displayName
    }
    investmentGeographies {
      id
      name
      displayName
    }
    investmentStages {
      id
      name
      displayName
    }
    logo {
      id
      key
    }
    address {
      city
      usState
      country
    }
  }
  saveInvestorProfile(input: $investorProfile) @include(if: $isInvestor) {
    id
    checkSizeMinDollars
    checkSizeMaxDollars
    canLeadInvestments
    isVerifiedInvestor
  }
}
    `;
export type SaveUserProfileMutationFn = Apollo.MutationFunction<SaveUserProfileMutation, SaveUserProfileMutationVariables>;

/**
 * __useSaveUserProfileMutation__
 *
 * To run a mutation, you first call `useSaveUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUserProfileMutation, { data, loading, error }] = useSaveUserProfileMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      companyProfileInput: // value for 'companyProfileInput'
 *      investorProfile: // value for 'investorProfile'
 *      isInvestor: // value for 'isInvestor'
 *   },
 * });
 */
export function useSaveUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<SaveUserProfileMutation, SaveUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveUserProfileMutation, SaveUserProfileMutationVariables>(SaveUserProfileDocument, options);
      }
export type SaveUserProfileMutationHookResult = ReturnType<typeof useSaveUserProfileMutation>;
export type SaveUserProfileMutationResult = Apollo.MutationResult<SaveUserProfileMutation>;
export type SaveUserProfileMutationOptions = Apollo.BaseMutationOptions<SaveUserProfileMutation, SaveUserProfileMutationVariables>;
export const EditUserModalDocument = gql`
    query EditUserModal($id: ID!, $isInvestor: Boolean!) {
  user(id: $id) {
    id
    firstName
    lastName
    email
    companyProfile {
      id
      name
      logo {
        id
        key
        fileName
      }
      websiteUrl
      description
      phoneNumber
      investmentStages {
        id
        name
        displayName
      }
      investmentCategory {
        id
        name
        displayName
      }
      investmentAreas {
        id
        displayName
      }
      investmentGeographies @include(if: $isInvestor) {
        id
        name
      }
      address {
        city
        usState
        country
      }
    }
    investorProfile @include(if: $isInvestor) {
      id
      canLeadInvestments
      checkSizeMinDollars
      checkSizeMaxDollars
      isVerifiedInvestor
    }
  }
}
    `;

/**
 * __useEditUserModalQuery__
 *
 * To run a query within a React component, call `useEditUserModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditUserModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditUserModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *      isInvestor: // value for 'isInvestor'
 *   },
 * });
 */
export function useEditUserModalQuery(baseOptions: Apollo.QueryHookOptions<EditUserModalQuery, EditUserModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditUserModalQuery, EditUserModalQueryVariables>(EditUserModalDocument, options);
      }
export function useEditUserModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditUserModalQuery, EditUserModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditUserModalQuery, EditUserModalQueryVariables>(EditUserModalDocument, options);
        }
export type EditUserModalQueryHookResult = ReturnType<typeof useEditUserModalQuery>;
export type EditUserModalLazyQueryHookResult = ReturnType<typeof useEditUserModalLazyQuery>;
export type EditUserModalQueryResult = Apollo.QueryResult<EditUserModalQuery, EditUserModalQueryVariables>;
export const FundraisingCampaignModalDocument = gql`
    query FundraisingCampaignModal($id: ID!) {
  campaign(id: $id) {
    id
    name
    description
    targetCloseDate
    targetAmountDollars
    fundingStage {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useFundraisingCampaignModalQuery__
 *
 * To run a query within a React component, call `useFundraisingCampaignModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundraisingCampaignModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundraisingCampaignModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFundraisingCampaignModalQuery(baseOptions: Apollo.QueryHookOptions<FundraisingCampaignModalQuery, FundraisingCampaignModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundraisingCampaignModalQuery, FundraisingCampaignModalQueryVariables>(FundraisingCampaignModalDocument, options);
      }
export function useFundraisingCampaignModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundraisingCampaignModalQuery, FundraisingCampaignModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundraisingCampaignModalQuery, FundraisingCampaignModalQueryVariables>(FundraisingCampaignModalDocument, options);
        }
export type FundraisingCampaignModalQueryHookResult = ReturnType<typeof useFundraisingCampaignModalQuery>;
export type FundraisingCampaignModalLazyQueryHookResult = ReturnType<typeof useFundraisingCampaignModalLazyQuery>;
export type FundraisingCampaignModalQueryResult = Apollo.QueryResult<FundraisingCampaignModalQuery, FundraisingCampaignModalQueryVariables>;
export const SaveCampaignDocument = gql`
    mutation SaveCampaign($input: SaveCampaignInput!) {
  saveCampaign(input: $input) {
    id
    name
    description
    targetCloseDate
    targetAmountDollars
    fundingStage {
      id
      name
      displayName
    }
  }
}
    `;
export type SaveCampaignMutationFn = Apollo.MutationFunction<SaveCampaignMutation, SaveCampaignMutationVariables>;

/**
 * __useSaveCampaignMutation__
 *
 * To run a mutation, you first call `useSaveCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCampaignMutation, { data, loading, error }] = useSaveCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SaveCampaignMutation, SaveCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCampaignMutation, SaveCampaignMutationVariables>(SaveCampaignDocument, options);
      }
export type SaveCampaignMutationHookResult = ReturnType<typeof useSaveCampaignMutation>;
export type SaveCampaignMutationResult = Apollo.MutationResult<SaveCampaignMutation>;
export type SaveCampaignMutationOptions = Apollo.BaseMutationOptions<SaveCampaignMutation, SaveCampaignMutationVariables>;
export const LegalTermDetailDocument = gql`
    query LegalTermDetail($title: String!) {
  legalTermDetail(title: $title) {
    id
    title
    description
    semantics
    illustrativeWording
    whatsTypical
    whereElseToCheckInTermSheet
    scenarioModeling
    whereToFindInFullDocs
  }
}
    `;

/**
 * __useLegalTermDetailQuery__
 *
 * To run a query within a React component, call `useLegalTermDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegalTermDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegalTermDetailQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useLegalTermDetailQuery(baseOptions: Apollo.QueryHookOptions<LegalTermDetailQuery, LegalTermDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegalTermDetailQuery, LegalTermDetailQueryVariables>(LegalTermDetailDocument, options);
      }
export function useLegalTermDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegalTermDetailQuery, LegalTermDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegalTermDetailQuery, LegalTermDetailQueryVariables>(LegalTermDetailDocument, options);
        }
export type LegalTermDetailQueryHookResult = ReturnType<typeof useLegalTermDetailQuery>;
export type LegalTermDetailLazyQueryHookResult = ReturnType<typeof useLegalTermDetailLazyQuery>;
export type LegalTermDetailQueryResult = Apollo.QueryResult<LegalTermDetailQuery, LegalTermDetailQueryVariables>;
export const ManageDownloadLimitsModalDocument = gql`
    query ManageDownloadLimitsModal {
  downloadLimitSettings {
    id
    limit
    category {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useManageDownloadLimitsModalQuery__
 *
 * To run a query within a React component, call `useManageDownloadLimitsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageDownloadLimitsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageDownloadLimitsModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useManageDownloadLimitsModalQuery(baseOptions?: Apollo.QueryHookOptions<ManageDownloadLimitsModalQuery, ManageDownloadLimitsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManageDownloadLimitsModalQuery, ManageDownloadLimitsModalQueryVariables>(ManageDownloadLimitsModalDocument, options);
      }
export function useManageDownloadLimitsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManageDownloadLimitsModalQuery, ManageDownloadLimitsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManageDownloadLimitsModalQuery, ManageDownloadLimitsModalQueryVariables>(ManageDownloadLimitsModalDocument, options);
        }
export type ManageDownloadLimitsModalQueryHookResult = ReturnType<typeof useManageDownloadLimitsModalQuery>;
export type ManageDownloadLimitsModalLazyQueryHookResult = ReturnType<typeof useManageDownloadLimitsModalLazyQuery>;
export type ManageDownloadLimitsModalQueryResult = Apollo.QueryResult<ManageDownloadLimitsModalQuery, ManageDownloadLimitsModalQueryVariables>;
export const SaveDownloadLimitSettingDocument = gql`
    mutation SaveDownloadLimitSetting($categoryName: DownloadLimitCategoryName!, $limit: Int!) {
  saveDownloadLimitSetting(input: {categoryName: $categoryName, limit: $limit}) {
    id
    limit
  }
}
    `;
export type SaveDownloadLimitSettingMutationFn = Apollo.MutationFunction<SaveDownloadLimitSettingMutation, SaveDownloadLimitSettingMutationVariables>;

/**
 * __useSaveDownloadLimitSettingMutation__
 *
 * To run a mutation, you first call `useSaveDownloadLimitSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDownloadLimitSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDownloadLimitSettingMutation, { data, loading, error }] = useSaveDownloadLimitSettingMutation({
 *   variables: {
 *      categoryName: // value for 'categoryName'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSaveDownloadLimitSettingMutation(baseOptions?: Apollo.MutationHookOptions<SaveDownloadLimitSettingMutation, SaveDownloadLimitSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveDownloadLimitSettingMutation, SaveDownloadLimitSettingMutationVariables>(SaveDownloadLimitSettingDocument, options);
      }
export type SaveDownloadLimitSettingMutationHookResult = ReturnType<typeof useSaveDownloadLimitSettingMutation>;
export type SaveDownloadLimitSettingMutationResult = Apollo.MutationResult<SaveDownloadLimitSettingMutation>;
export type SaveDownloadLimitSettingMutationOptions = Apollo.BaseMutationOptions<SaveDownloadLimitSettingMutation, SaveDownloadLimitSettingMutationVariables>;
export const PitchDeckTopicDetailDocument = gql`
    query PitchDeckTopicDetail($title: String!) {
  pitchDeckTopicDetail(title: $title) {
    id
    title
    description
    whyIsThisImportant
    whatYouWillNeed
    potentialPitfalls
    commonSuccesses
    closingThoughts
  }
}
    `;

/**
 * __usePitchDeckTopicDetailQuery__
 *
 * To run a query within a React component, call `usePitchDeckTopicDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePitchDeckTopicDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePitchDeckTopicDetailQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function usePitchDeckTopicDetailQuery(baseOptions: Apollo.QueryHookOptions<PitchDeckTopicDetailQuery, PitchDeckTopicDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PitchDeckTopicDetailQuery, PitchDeckTopicDetailQueryVariables>(PitchDeckTopicDetailDocument, options);
      }
export function usePitchDeckTopicDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PitchDeckTopicDetailQuery, PitchDeckTopicDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PitchDeckTopicDetailQuery, PitchDeckTopicDetailQueryVariables>(PitchDeckTopicDetailDocument, options);
        }
export type PitchDeckTopicDetailQueryHookResult = ReturnType<typeof usePitchDeckTopicDetailQuery>;
export type PitchDeckTopicDetailLazyQueryHookResult = ReturnType<typeof usePitchDeckTopicDetailLazyQuery>;
export type PitchDeckTopicDetailQueryResult = Apollo.QueryResult<PitchDeckTopicDetailQuery, PitchDeckTopicDetailQueryVariables>;
export const SaveNoteDocument = gql`
    mutation SaveNote($input: SaveNoteInput!) {
  saveNote(input: $input) {
    id
    title
    body
  }
}
    `;
export type SaveNoteMutationFn = Apollo.MutationFunction<SaveNoteMutation, SaveNoteMutationVariables>;

/**
 * __useSaveNoteMutation__
 *
 * To run a mutation, you first call `useSaveNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveNoteMutation, { data, loading, error }] = useSaveNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveNoteMutation(baseOptions?: Apollo.MutationHookOptions<SaveNoteMutation, SaveNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveNoteMutation, SaveNoteMutationVariables>(SaveNoteDocument, options);
      }
export type SaveNoteMutationHookResult = ReturnType<typeof useSaveNoteMutation>;
export type SaveNoteMutationResult = Apollo.MutationResult<SaveNoteMutation>;
export type SaveNoteMutationOptions = Apollo.BaseMutationOptions<SaveNoteMutation, SaveNoteMutationVariables>;
export const SaveNoteModalDocument = gql`
    query SaveNoteModal($id: ID!) {
  note(id: $id) {
    id
    title
    body
  }
}
    `;

/**
 * __useSaveNoteModalQuery__
 *
 * To run a query within a React component, call `useSaveNoteModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaveNoteModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaveNoteModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSaveNoteModalQuery(baseOptions: Apollo.QueryHookOptions<SaveNoteModalQuery, SaveNoteModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaveNoteModalQuery, SaveNoteModalQueryVariables>(SaveNoteModalDocument, options);
      }
export function useSaveNoteModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaveNoteModalQuery, SaveNoteModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaveNoteModalQuery, SaveNoteModalQueryVariables>(SaveNoteModalDocument, options);
        }
export type SaveNoteModalQueryHookResult = ReturnType<typeof useSaveNoteModalQuery>;
export type SaveNoteModalLazyQueryHookResult = ReturnType<typeof useSaveNoteModalLazyQuery>;
export type SaveNoteModalQueryResult = Apollo.QueryResult<SaveNoteModalQuery, SaveNoteModalQueryVariables>;
export const BulkImportInvestmentAreasDocument = gql`
    mutation BulkImportInvestmentAreas($input: BulkImportInvestmentAreasInput!) {
  bulkImportInvestmentAreas(input: $input) {
    id
    displayName
  }
}
    `;
export type BulkImportInvestmentAreasMutationFn = Apollo.MutationFunction<BulkImportInvestmentAreasMutation, BulkImportInvestmentAreasMutationVariables>;

/**
 * __useBulkImportInvestmentAreasMutation__
 *
 * To run a mutation, you first call `useBulkImportInvestmentAreasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkImportInvestmentAreasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkImportInvestmentAreasMutation, { data, loading, error }] = useBulkImportInvestmentAreasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkImportInvestmentAreasMutation(baseOptions?: Apollo.MutationHookOptions<BulkImportInvestmentAreasMutation, BulkImportInvestmentAreasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkImportInvestmentAreasMutation, BulkImportInvestmentAreasMutationVariables>(BulkImportInvestmentAreasDocument, options);
      }
export type BulkImportInvestmentAreasMutationHookResult = ReturnType<typeof useBulkImportInvestmentAreasMutation>;
export type BulkImportInvestmentAreasMutationResult = Apollo.MutationResult<BulkImportInvestmentAreasMutation>;
export type BulkImportInvestmentAreasMutationOptions = Apollo.BaseMutationOptions<BulkImportInvestmentAreasMutation, BulkImportInvestmentAreasMutationVariables>;
export const BulkImportUsersDocument = gql`
    mutation BulkImportUsers($input: BulkImportUsersInput!) {
  bulkImportUsers(input: $input) {
    id
  }
}
    `;
export type BulkImportUsersMutationFn = Apollo.MutationFunction<BulkImportUsersMutation, BulkImportUsersMutationVariables>;

/**
 * __useBulkImportUsersMutation__
 *
 * To run a mutation, you first call `useBulkImportUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkImportUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkImportUsersMutation, { data, loading, error }] = useBulkImportUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkImportUsersMutation(baseOptions?: Apollo.MutationHookOptions<BulkImportUsersMutation, BulkImportUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkImportUsersMutation, BulkImportUsersMutationVariables>(BulkImportUsersDocument, options);
      }
export type BulkImportUsersMutationHookResult = ReturnType<typeof useBulkImportUsersMutation>;
export type BulkImportUsersMutationResult = Apollo.MutationResult<BulkImportUsersMutation>;
export type BulkImportUsersMutationOptions = Apollo.BaseMutationOptions<BulkImportUsersMutation, BulkImportUsersMutationVariables>;
export const UploadUsersModalDocument = gql`
    query UploadUsersModal {
  investmentAreas {
    id
    displayName
  }
  investmentGeographies {
    id
    name
    parentName
  }
}
    `;

/**
 * __useUploadUsersModalQuery__
 *
 * To run a query within a React component, call `useUploadUsersModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadUsersModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadUsersModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useUploadUsersModalQuery(baseOptions?: Apollo.QueryHookOptions<UploadUsersModalQuery, UploadUsersModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UploadUsersModalQuery, UploadUsersModalQueryVariables>(UploadUsersModalDocument, options);
      }
export function useUploadUsersModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UploadUsersModalQuery, UploadUsersModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UploadUsersModalQuery, UploadUsersModalQueryVariables>(UploadUsersModalDocument, options);
        }
export type UploadUsersModalQueryHookResult = ReturnType<typeof useUploadUsersModalQuery>;
export type UploadUsersModalLazyQueryHookResult = ReturnType<typeof useUploadUsersModalLazyQuery>;
export type UploadUsersModalQueryResult = Apollo.QueryResult<UploadUsersModalQuery, UploadUsersModalQueryVariables>;
export const ValidateEmailsAvailableDocument = gql`
    query validateEmailsAvailable($emails: [String!]!) {
  validateEmailsAvailable(emails: $emails)
}
    `;

/**
 * __useValidateEmailsAvailableQuery__
 *
 * To run a query within a React component, call `useValidateEmailsAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateEmailsAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateEmailsAvailableQuery({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useValidateEmailsAvailableQuery(baseOptions: Apollo.QueryHookOptions<ValidateEmailsAvailableQuery, ValidateEmailsAvailableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateEmailsAvailableQuery, ValidateEmailsAvailableQueryVariables>(ValidateEmailsAvailableDocument, options);
      }
export function useValidateEmailsAvailableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateEmailsAvailableQuery, ValidateEmailsAvailableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateEmailsAvailableQuery, ValidateEmailsAvailableQueryVariables>(ValidateEmailsAvailableDocument, options);
        }
export type ValidateEmailsAvailableQueryHookResult = ReturnType<typeof useValidateEmailsAvailableQuery>;
export type ValidateEmailsAvailableLazyQueryHookResult = ReturnType<typeof useValidateEmailsAvailableLazyQuery>;
export type ValidateEmailsAvailableQueryResult = Apollo.QueryResult<ValidateEmailsAvailableQuery, ValidateEmailsAvailableQueryVariables>;
export const RestrictToSubscriptionProviderDocument = gql`
    query RestrictToSubscriptionProvider {
  loggedInUser {
    id
    subscriptionStatus
  }
}
    `;

/**
 * __useRestrictToSubscriptionProviderQuery__
 *
 * To run a query within a React component, call `useRestrictToSubscriptionProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useRestrictToSubscriptionProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRestrictToSubscriptionProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useRestrictToSubscriptionProviderQuery(baseOptions?: Apollo.QueryHookOptions<RestrictToSubscriptionProviderQuery, RestrictToSubscriptionProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RestrictToSubscriptionProviderQuery, RestrictToSubscriptionProviderQueryVariables>(RestrictToSubscriptionProviderDocument, options);
      }
export function useRestrictToSubscriptionProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RestrictToSubscriptionProviderQuery, RestrictToSubscriptionProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RestrictToSubscriptionProviderQuery, RestrictToSubscriptionProviderQueryVariables>(RestrictToSubscriptionProviderDocument, options);
        }
export type RestrictToSubscriptionProviderQueryHookResult = ReturnType<typeof useRestrictToSubscriptionProviderQuery>;
export type RestrictToSubscriptionProviderLazyQueryHookResult = ReturnType<typeof useRestrictToSubscriptionProviderLazyQuery>;
export type RestrictToSubscriptionProviderQueryResult = Apollo.QueryResult<RestrictToSubscriptionProviderQuery, RestrictToSubscriptionProviderQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "AccessPass",
      "SiteUserFull"
    ],
    "Page": [
      "AccessPassPage",
      "SiteUserFullPage"
    ]
  }
};
      export default result;
    